import { jsx as ka } from "react/jsx-runtime";
import { c as mt, g as gt } from "./_commonjsHelpers.js";
import { g as or } from "./PurePanel.js";
import * as o from "react";
import Qt, { useMemo as wa, forwardRef as ir, useContext as Jt, useImperativeHandle as lr } from "react";
import { _ as Se } from "./extends.js";
import { I as Ln } from "./AntdIcon.js";
import { n as $e, c as pe, R as Be, w as Ge, _ as ie, d as B, q as Ht, h as Ye, P as nt, i as Ma, k as lt, v as xt, a as $a, b as Da, m as Hn, u as he, $ as en, g as Pa, o as Qn, A as Ia, E as Ea, C as ur } from "./CSSMotionList.js";
import { u as rt, a as cr } from "./useSize.js";
import { o as sr } from "./omit.js";
import { p as Bn } from "./pickAttrs.js";
import { T as Na, a as Ra, g as Oa } from "./roundedArrow.js";
import { R as dr } from "./index5.js";
import { i as _a, u as fr, a as vr, F as mr, C as gr } from "./ContextIsolator.js";
import { F as Va, a as Ha, s as Ta, c as Fa, b as Ya, i as Zn, d as Jn } from "./Overflow.js";
import { u as hr } from "./Portal.js";
import { a as Aa, d as La, e as Ba, f as Wa, h as ja, i as za, j as Ua, c as pr, g as Cr } from "./index4.js";
import { d as br } from "./warning.js";
import { D as Sr, d as yr } from "./index.js";
import { u as xr } from "./useVariants.js";
import { g as qa } from "./compact-item.js";
import { g as Ka, a as Ga, u as Xa } from "./useIcons.js";
import { B as Qa } from "./button2.js";
import { u as kr } from "./useLocale.js";
var wr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    var n = 1e3, r = 6e4, a = 36e5, i = "millisecond", l = "second", u = "minute", s = "hour", f = "day", c = "week", d = "month", m = "quarter", p = "year", C = "date", S = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(x) {
      var g = ["th", "st", "nd", "rd"], b = x % 100;
      return "[" + x + (g[(b - 20) % 10] || g[b] || g[0]) + "]";
    } }, k = function(x, g, b) {
      var $ = String(x);
      return !$ || $.length >= g ? x : "" + Array(g + 1 - $.length).join(b) + x;
    }, y = { s: k, z: function(x) {
      var g = -x.utcOffset(), b = Math.abs(g), $ = Math.floor(b / 60), w = b % 60;
      return (g <= 0 ? "+" : "-") + k($, 2, "0") + ":" + k(w, 2, "0");
    }, m: function x(g, b) {
      if (g.date() < b.date()) return -x(b, g);
      var $ = 12 * (b.year() - g.year()) + (b.month() - g.month()), w = g.clone().add($, d), H = b - w < 0, R = g.clone().add($ + (H ? -1 : 1), d);
      return +(-($ + (b - w) / (H ? w - R : R - w)) || 0);
    }, a: function(x) {
      return x < 0 ? Math.ceil(x) || 0 : Math.floor(x);
    }, p: function(x) {
      return { M: d, y: p, w: c, d: f, D: C, h: s, m: u, s: l, ms: i, Q: m }[x] || String(x || "").toLowerCase().replace(/s$/, "");
    }, u: function(x) {
      return x === void 0;
    } }, I = "en", P = {};
    P[I] = M;
    var E = "$isDayjsObject", L = function(x) {
      return x instanceof A || !(!x || !x[E]);
    }, Y = function x(g, b, $) {
      var w;
      if (!g) return I;
      if (typeof g == "string") {
        var H = g.toLowerCase();
        P[H] && (w = H), b && (P[H] = b, w = H);
        var R = g.split("-");
        if (!w && R.length > 1) return x(R[0]);
      } else {
        var N = g.name;
        P[N] = g, w = N;
      }
      return !$ && w && (I = w), w || !$ && I;
    }, O = function(x, g) {
      if (L(x)) return x.clone();
      var b = typeof g == "object" ? g : {};
      return b.date = x, b.args = arguments, new A(b);
    }, V = y;
    V.l = Y, V.i = L, V.w = function(x, g) {
      return O(x, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
    };
    var A = function() {
      function x(b) {
        this.$L = Y(b.locale, null, !0), this.parse(b), this.$x = this.$x || b.x || {}, this[E] = !0;
      }
      var g = x.prototype;
      return g.parse = function(b) {
        this.$d = function($) {
          var w = $.date, H = $.utc;
          if (w === null) return /* @__PURE__ */ new Date(NaN);
          if (V.u(w)) return /* @__PURE__ */ new Date();
          if (w instanceof Date) return new Date(w);
          if (typeof w == "string" && !/Z$/i.test(w)) {
            var R = w.match(v);
            if (R) {
              var N = R[2] - 1 || 0, D = (R[7] || "0").substring(0, 3);
              return H ? new Date(Date.UTC(R[1], N, R[3] || 1, R[4] || 0, R[5] || 0, R[6] || 0, D)) : new Date(R[1], N, R[3] || 1, R[4] || 0, R[5] || 0, R[6] || 0, D);
            }
          }
          return new Date(w);
        }(b), this.init();
      }, g.init = function() {
        var b = this.$d;
        this.$y = b.getFullYear(), this.$M = b.getMonth(), this.$D = b.getDate(), this.$W = b.getDay(), this.$H = b.getHours(), this.$m = b.getMinutes(), this.$s = b.getSeconds(), this.$ms = b.getMilliseconds();
      }, g.$utils = function() {
        return V;
      }, g.isValid = function() {
        return this.$d.toString() !== S;
      }, g.isSame = function(b, $) {
        var w = O(b);
        return this.startOf($) <= w && w <= this.endOf($);
      }, g.isAfter = function(b, $) {
        return O(b) < this.startOf($);
      }, g.isBefore = function(b, $) {
        return this.endOf($) < O(b);
      }, g.$g = function(b, $, w) {
        return V.u(b) ? this[$] : this.set(w, b);
      }, g.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, g.valueOf = function() {
        return this.$d.getTime();
      }, g.startOf = function(b, $) {
        var w = this, H = !!V.u($) || $, R = V.p(b), N = function(K, W) {
          var U = V.w(w.$u ? Date.UTC(w.$y, W, K) : new Date(w.$y, W, K), w);
          return H ? U : U.endOf(f);
        }, D = function(K, W) {
          return V.w(w.toDate()[K].apply(w.toDate("s"), (H ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), w);
        }, _ = this.$W, F = this.$M, q = this.$D, X = "set" + (this.$u ? "UTC" : "");
        switch (R) {
          case p:
            return H ? N(1, 0) : N(31, 11);
          case d:
            return H ? N(1, F) : N(0, F + 1);
          case c:
            var z = this.$locale().weekStart || 0, Q = (_ < z ? _ + 7 : _) - z;
            return N(H ? q - Q : q + (6 - Q), F);
          case f:
          case C:
            return D(X + "Hours", 0);
          case s:
            return D(X + "Minutes", 1);
          case u:
            return D(X + "Seconds", 2);
          case l:
            return D(X + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, g.endOf = function(b) {
        return this.startOf(b, !1);
      }, g.$set = function(b, $) {
        var w, H = V.p(b), R = "set" + (this.$u ? "UTC" : ""), N = (w = {}, w[f] = R + "Date", w[C] = R + "Date", w[d] = R + "Month", w[p] = R + "FullYear", w[s] = R + "Hours", w[u] = R + "Minutes", w[l] = R + "Seconds", w[i] = R + "Milliseconds", w)[H], D = H === f ? this.$D + ($ - this.$W) : $;
        if (H === d || H === p) {
          var _ = this.clone().set(C, 1);
          _.$d[N](D), _.init(), this.$d = _.set(C, Math.min(this.$D, _.daysInMonth())).$d;
        } else N && this.$d[N](D);
        return this.init(), this;
      }, g.set = function(b, $) {
        return this.clone().$set(b, $);
      }, g.get = function(b) {
        return this[V.p(b)]();
      }, g.add = function(b, $) {
        var w, H = this;
        b = Number(b);
        var R = V.p($), N = function(F) {
          var q = O(H);
          return V.w(q.date(q.date() + Math.round(F * b)), H);
        };
        if (R === d) return this.set(d, this.$M + b);
        if (R === p) return this.set(p, this.$y + b);
        if (R === f) return N(1);
        if (R === c) return N(7);
        var D = (w = {}, w[u] = r, w[s] = a, w[l] = n, w)[R] || 1, _ = this.$d.getTime() + b * D;
        return V.w(_, this);
      }, g.subtract = function(b, $) {
        return this.add(-1 * b, $);
      }, g.format = function(b) {
        var $ = this, w = this.$locale();
        if (!this.isValid()) return w.invalidDate || S;
        var H = b || "YYYY-MM-DDTHH:mm:ssZ", R = V.z(this), N = this.$H, D = this.$m, _ = this.$M, F = w.weekdays, q = w.months, X = w.meridiem, z = function(W, U, re, te) {
          return W && (W[U] || W($, H)) || re[U].slice(0, te);
        }, Q = function(W) {
          return V.s(N % 12 || 12, W, "0");
        }, K = X || function(W, U, re) {
          var te = W < 12 ? "AM" : "PM";
          return re ? te.toLowerCase() : te;
        };
        return H.replace(h, function(W, U) {
          return U || function(re) {
            switch (re) {
              case "YY":
                return String($.$y).slice(-2);
              case "YYYY":
                return V.s($.$y, 4, "0");
              case "M":
                return _ + 1;
              case "MM":
                return V.s(_ + 1, 2, "0");
              case "MMM":
                return z(w.monthsShort, _, q, 3);
              case "MMMM":
                return z(q, _);
              case "D":
                return $.$D;
              case "DD":
                return V.s($.$D, 2, "0");
              case "d":
                return String($.$W);
              case "dd":
                return z(w.weekdaysMin, $.$W, F, 2);
              case "ddd":
                return z(w.weekdaysShort, $.$W, F, 3);
              case "dddd":
                return F[$.$W];
              case "H":
                return String(N);
              case "HH":
                return V.s(N, 2, "0");
              case "h":
                return Q(1);
              case "hh":
                return Q(2);
              case "a":
                return K(N, D, !0);
              case "A":
                return K(N, D, !1);
              case "m":
                return String(D);
              case "mm":
                return V.s(D, 2, "0");
              case "s":
                return String($.$s);
              case "ss":
                return V.s($.$s, 2, "0");
              case "SSS":
                return V.s($.$ms, 3, "0");
              case "Z":
                return R;
            }
            return null;
          }(W) || R.replace(":", "");
        });
      }, g.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, g.diff = function(b, $, w) {
        var H, R = this, N = V.p($), D = O(b), _ = (D.utcOffset() - this.utcOffset()) * r, F = this - D, q = function() {
          return V.m(R, D);
        };
        switch (N) {
          case p:
            H = q() / 12;
            break;
          case d:
            H = q();
            break;
          case m:
            H = q() / 3;
            break;
          case c:
            H = (F - _) / 6048e5;
            break;
          case f:
            H = (F - _) / 864e5;
            break;
          case s:
            H = F / a;
            break;
          case u:
            H = F / r;
            break;
          case l:
            H = F / n;
            break;
          default:
            H = F;
        }
        return w ? H : V.a(H);
      }, g.daysInMonth = function() {
        return this.endOf(d).$D;
      }, g.$locale = function() {
        return P[this.$L];
      }, g.locale = function(b, $) {
        if (!b) return this.$L;
        var w = this.clone(), H = Y(b, $, !0);
        return H && (w.$L = H), w;
      }, g.clone = function() {
        return V.w(this.$d, this);
      }, g.toDate = function() {
        return new Date(this.valueOf());
      }, g.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, g.toISOString = function() {
        return this.$d.toISOString();
      }, g.toString = function() {
        return this.$d.toUTCString();
      }, x;
    }(), T = A.prototype;
    return O.prototype = T, [["$ms", i], ["$s", l], ["$m", u], ["$H", s], ["$W", f], ["$M", d], ["$y", p], ["$D", C]].forEach(function(x) {
      T[x[1]] = function(g) {
        return this.$g(g, x[0], x[1]);
      };
    }), O.extend = function(x, g) {
      return x.$i || (x(g, A, O), x.$i = !0), O;
    }, O.locale = Y, O.isDayjs = L, O.unix = function(x) {
      return O(1e3 * x);
    }, O.en = P[I], O.Ls = P, O.p = {}, O;
  });
})(wr);
var Za = wr.exports;
const ze = /* @__PURE__ */ gt(Za);
var Mr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    return function(n, r) {
      r.prototype.weekday = function(a) {
        var i = this.$locale().weekStart || 0, l = this.$W, u = (l < i ? l + 7 : l) - i;
        return this.$utils().u(a) ? u : this.subtract(u, "day").add(a, "day");
      };
    };
  });
})(Mr);
var Ja = Mr.exports;
const eo = /* @__PURE__ */ gt(Ja);
var $r = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    return function(n, r, a) {
      var i = r.prototype, l = function(d) {
        return d && (d.indexOf ? d : d.s);
      }, u = function(d, m, p, C, S) {
        var v = d.name ? d : d.$locale(), h = l(v[m]), M = l(v[p]), k = h || M.map(function(I) {
          return I.slice(0, C);
        });
        if (!S) return k;
        var y = v.weekStart;
        return k.map(function(I, P) {
          return k[(P + (y || 0)) % 7];
        });
      }, s = function() {
        return a.Ls[a.locale()];
      }, f = function(d, m) {
        return d.formats[m] || function(p) {
          return p.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(C, S, v) {
            return S || v.slice(1);
          });
        }(d.formats[m.toUpperCase()]);
      }, c = function() {
        var d = this;
        return { months: function(m) {
          return m ? m.format("MMMM") : u(d, "months");
        }, monthsShort: function(m) {
          return m ? m.format("MMM") : u(d, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return d.$locale().weekStart || 0;
        }, weekdays: function(m) {
          return m ? m.format("dddd") : u(d, "weekdays");
        }, weekdaysMin: function(m) {
          return m ? m.format("dd") : u(d, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(m) {
          return m ? m.format("ddd") : u(d, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(m) {
          return f(d.$locale(), m);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      i.localeData = function() {
        return c.bind(this)();
      }, a.localeData = function() {
        var d = s();
        return { firstDayOfWeek: function() {
          return d.weekStart || 0;
        }, weekdays: function() {
          return a.weekdays();
        }, weekdaysShort: function() {
          return a.weekdaysShort();
        }, weekdaysMin: function() {
          return a.weekdaysMin();
        }, months: function() {
          return a.months();
        }, monthsShort: function() {
          return a.monthsShort();
        }, longDateFormat: function(m) {
          return f(d, m);
        }, meridiem: d.meridiem, ordinal: d.ordinal };
      }, a.months = function() {
        return u(s(), "months");
      }, a.monthsShort = function() {
        return u(s(), "monthsShort", "months", 3);
      }, a.weekdays = function(d) {
        return u(s(), "weekdays", null, null, d);
      }, a.weekdaysShort = function(d) {
        return u(s(), "weekdaysShort", "weekdays", 3, d);
      }, a.weekdaysMin = function(d) {
        return u(s(), "weekdaysMin", "weekdays", 2, d);
      };
    };
  });
})($r);
var to = $r.exports;
const no = /* @__PURE__ */ gt(to);
var Dr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    var n = "week", r = "year";
    return function(a, i, l) {
      var u = i.prototype;
      u.week = function(s) {
        if (s === void 0 && (s = null), s !== null) return this.add(7 * (s - this.week()), "day");
        var f = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var c = l(this).startOf(r).add(1, r).date(f), d = l(this).endOf(n);
          if (c.isBefore(d)) return 1;
        }
        var m = l(this).startOf(r).date(f).startOf(n).subtract(1, "millisecond"), p = this.diff(m, n, !0);
        return p < 0 ? l(this).startOf("week").week() : Math.ceil(p);
      }, u.weeks = function(s) {
        return s === void 0 && (s = null), this.week(s);
      };
    };
  });
})(Dr);
var ro = Dr.exports;
const ao = /* @__PURE__ */ gt(ro);
var Pr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var a = this.month(), i = this.week(), l = this.year();
        return i === 1 && a === 11 ? l + 1 : a === 0 && i >= 52 ? l - 1 : l;
      };
    };
  });
})(Pr);
var oo = Pr.exports;
const io = /* @__PURE__ */ gt(oo);
var Ir = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    return function(n, r) {
      var a = r.prototype, i = a.format;
      a.format = function(l) {
        var u = this, s = this.$locale();
        if (!this.isValid()) return i.bind(this)(l);
        var f = this.$utils(), c = (l || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(d) {
          switch (d) {
            case "Q":
              return Math.ceil((u.$M + 1) / 3);
            case "Do":
              return s.ordinal(u.$D);
            case "gggg":
              return u.weekYear();
            case "GGGG":
              return u.isoWeekYear();
            case "wo":
              return s.ordinal(u.week(), "W");
            case "w":
            case "ww":
              return f.s(u.week(), d === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return f.s(u.isoWeek(), d === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return f.s(String(u.$H === 0 ? 24 : u.$H), d === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(u.$d.getTime() / 1e3);
            case "x":
              return u.$d.getTime();
            case "z":
              return "[" + u.offsetName() + "]";
            case "zzz":
              return "[" + u.offsetName("long") + "]";
            default:
              return d;
          }
        });
        return i.bind(this)(c);
      };
    };
  });
})(Ir);
var lo = Ir.exports;
const uo = /* @__PURE__ */ gt(lo);
var Er = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(mt, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d/, i = /\d\d/, l = /\d\d?/, u = /\d*[^-_:/,()\s\d]+/, s = {}, f = function(v) {
      return (v = +v) + (v > 68 ? 1900 : 2e3);
    }, c = function(v) {
      return function(h) {
        this[v] = +h;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(v) {
      (this.zone || (this.zone = {})).offset = function(h) {
        if (!h || h === "Z") return 0;
        var M = h.match(/([+-]|\d\d)/g), k = 60 * M[1] + (+M[2] || 0);
        return k === 0 ? 0 : M[0] === "+" ? -k : k;
      }(v);
    }], m = function(v) {
      var h = s[v];
      return h && (h.indexOf ? h : h.s.concat(h.f));
    }, p = function(v, h) {
      var M, k = s.meridiem;
      if (k) {
        for (var y = 1; y <= 24; y += 1) if (v.indexOf(k(y, 0, h)) > -1) {
          M = y > 12;
          break;
        }
      } else M = v === (h ? "pm" : "PM");
      return M;
    }, C = { A: [u, function(v) {
      this.afternoon = p(v, !1);
    }], a: [u, function(v) {
      this.afternoon = p(v, !0);
    }], Q: [a, function(v) {
      this.month = 3 * (v - 1) + 1;
    }], S: [a, function(v) {
      this.milliseconds = 100 * +v;
    }], SS: [i, function(v) {
      this.milliseconds = 10 * +v;
    }], SSS: [/\d{3}/, function(v) {
      this.milliseconds = +v;
    }], s: [l, c("seconds")], ss: [l, c("seconds")], m: [l, c("minutes")], mm: [l, c("minutes")], H: [l, c("hours")], h: [l, c("hours")], HH: [l, c("hours")], hh: [l, c("hours")], D: [l, c("day")], DD: [i, c("day")], Do: [u, function(v) {
      var h = s.ordinal, M = v.match(/\d+/);
      if (this.day = M[0], h) for (var k = 1; k <= 31; k += 1) h(k).replace(/\[|\]/g, "") === v && (this.day = k);
    }], w: [l, c("week")], ww: [i, c("week")], M: [l, c("month")], MM: [i, c("month")], MMM: [u, function(v) {
      var h = m("months"), M = (m("monthsShort") || h.map(function(k) {
        return k.slice(0, 3);
      })).indexOf(v) + 1;
      if (M < 1) throw new Error();
      this.month = M % 12 || M;
    }], MMMM: [u, function(v) {
      var h = m("months").indexOf(v) + 1;
      if (h < 1) throw new Error();
      this.month = h % 12 || h;
    }], Y: [/[+-]?\d+/, c("year")], YY: [i, function(v) {
      this.year = f(v);
    }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
    function S(v) {
      var h, M;
      h = v, M = s && s.formats;
      for (var k = (v = h.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(O, V, A) {
        var T = A && A.toUpperCase();
        return V || M[A] || n[A] || M[T].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(x, g, b) {
          return g || b.slice(1);
        });
      })).match(r), y = k.length, I = 0; I < y; I += 1) {
        var P = k[I], E = C[P], L = E && E[0], Y = E && E[1];
        k[I] = Y ? { regex: L, parser: Y } : P.replace(/^\[|\]$/g, "");
      }
      return function(O) {
        for (var V = {}, A = 0, T = 0; A < y; A += 1) {
          var x = k[A];
          if (typeof x == "string") T += x.length;
          else {
            var g = x.regex, b = x.parser, $ = O.slice(T), w = g.exec($)[0];
            b.call(V, w), O = O.replace(w, "");
          }
        }
        return function(H) {
          var R = H.afternoon;
          if (R !== void 0) {
            var N = H.hours;
            R ? N < 12 && (H.hours += 12) : N === 12 && (H.hours = 0), delete H.afternoon;
          }
        }(V), V;
      };
    }
    return function(v, h, M) {
      M.p.customParseFormat = !0, v && v.parseTwoDigitYear && (f = v.parseTwoDigitYear);
      var k = h.prototype, y = k.parse;
      k.parse = function(I) {
        var P = I.date, E = I.utc, L = I.args;
        this.$u = E;
        var Y = L[1];
        if (typeof Y == "string") {
          var O = L[2] === !0, V = L[3] === !0, A = O || V, T = L[2];
          V && (T = L[2]), s = this.$locale(), !O && T && (s = M.Ls[T]), this.$d = function($, w, H, R) {
            try {
              if (["x", "X"].indexOf(w) > -1) return new Date((w === "X" ? 1e3 : 1) * $);
              var N = S(w)($), D = N.year, _ = N.month, F = N.day, q = N.hours, X = N.minutes, z = N.seconds, Q = N.milliseconds, K = N.zone, W = N.week, U = /* @__PURE__ */ new Date(), re = F || (D || _ ? 1 : U.getDate()), te = D || U.getFullYear(), le = 0;
              D && !_ || (le = _ > 0 ? _ - 1 : U.getMonth());
              var ge, J = q || 0, Ce = X || 0, ue = z || 0, xe = Q || 0;
              return K ? new Date(Date.UTC(te, le, re, J, Ce, ue, xe + 60 * K.offset * 1e3)) : H ? new Date(Date.UTC(te, le, re, J, Ce, ue, xe)) : (ge = new Date(te, le, re, J, Ce, ue, xe), W && (ge = R(ge).week(W).toDate()), ge);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(P, Y, E, M), this.init(), T && T !== !0 && (this.$L = this.locale(T).$L), A && P != this.format(Y) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (Y instanceof Array) for (var x = Y.length, g = 1; g <= x; g += 1) {
          L[1] = Y[g - 1];
          var b = M.apply(this, L);
          if (b.isValid()) {
            this.$d = b.$d, this.$L = b.$L, this.init();
            break;
          }
          g === x && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else y.call(this, I);
      };
    };
  });
})(Er);
var co = Er.exports;
const so = /* @__PURE__ */ gt(co);
ze.extend(so);
ze.extend(uo);
ze.extend(eo);
ze.extend(no);
ze.extend(ao);
ze.extend(io);
ze.extend(function(e, t) {
  var n = t.prototype, r = n.format;
  n.format = function(i) {
    var l = (i || "").replace("Wo", "wo");
    return r.bind(this)(l);
  };
});
var fo = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, ft = function(t) {
  var n = fo[t];
  return n || t.split("_")[0];
}, vo = {
  // get
  getNow: function() {
    var t = ze();
    return typeof t.tz == "function" ? t.tz() : t;
  },
  getFixedDate: function(t) {
    return ze(t, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(t) {
    return t.endOf("month");
  },
  getWeekDay: function(t) {
    var n = t.locale("en");
    return n.weekday() + n.localeData().firstDayOfWeek();
  },
  getYear: function(t) {
    return t.year();
  },
  getMonth: function(t) {
    return t.month();
  },
  getDate: function(t) {
    return t.date();
  },
  getHour: function(t) {
    return t.hour();
  },
  getMinute: function(t) {
    return t.minute();
  },
  getSecond: function(t) {
    return t.second();
  },
  getMillisecond: function(t) {
    return t.millisecond();
  },
  // set
  addYear: function(t, n) {
    return t.add(n, "year");
  },
  addMonth: function(t, n) {
    return t.add(n, "month");
  },
  addDate: function(t, n) {
    return t.add(n, "day");
  },
  setYear: function(t, n) {
    return t.year(n);
  },
  setMonth: function(t, n) {
    return t.month(n);
  },
  setDate: function(t, n) {
    return t.date(n);
  },
  setHour: function(t, n) {
    return t.hour(n);
  },
  setMinute: function(t, n) {
    return t.minute(n);
  },
  setSecond: function(t, n) {
    return t.second(n);
  },
  setMillisecond: function(t, n) {
    return t.millisecond(n);
  },
  // Compare
  isAfter: function(t, n) {
    return t.isAfter(n);
  },
  isValidate: function(t) {
    return t.isValid();
  },
  locale: {
    getWeekFirstDay: function(t) {
      return ze().locale(ft(t)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(t, n) {
      return n.locale(ft(t)).weekday(0);
    },
    getWeek: function(t, n) {
      return n.locale(ft(t)).week();
    },
    getShortWeekDays: function(t) {
      return ze().locale(ft(t)).localeData().weekdaysMin();
    },
    getShortMonths: function(t) {
      return ze().locale(ft(t)).localeData().monthsShort();
    },
    format: function(t, n, r) {
      return n.locale(ft(t)).format(r);
    },
    parse: function(t, n, r) {
      for (var a = ft(t), i = 0; i < r.length; i += 1) {
        var l = r[i], u = n;
        if (l.includes("wo") || l.includes("Wo")) {
          for (var s = u.split("-")[0], f = u.split("-")[1], c = ze(s, "YYYY").startOf("year").locale(a), d = 0; d <= 52; d += 1) {
            var m = c.add(d, "week");
            if (m.format("Wo") === f)
              return m;
          }
          return null;
        }
        var p = ze(u, l, !0).locale(a);
        if (p.isValid())
          return p;
      }
      return null;
    }
  }
};
function mo(e, t) {
  return e !== void 0 ? e : t ? "bottomRight" : "bottomLeft";
}
var Xe = /* @__PURE__ */ o.createContext(null), go = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function Nr(e) {
  var t = e.popupElement, n = e.popupStyle, r = e.popupClassName, a = e.popupAlign, i = e.transitionName, l = e.getPopupContainer, u = e.children, s = e.range, f = e.placement, c = e.builtinPlacements, d = c === void 0 ? go : c, m = e.direction, p = e.visible, C = e.onClose, S = o.useContext(Xe), v = S.prefixCls, h = "".concat(v, "-dropdown"), M = mo(f, m === "rtl");
  return /* @__PURE__ */ o.createElement(Na, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: M,
    builtinPlacements: d,
    prefixCls: h,
    popupTransitionName: i,
    popup: t,
    popupAlign: a,
    popupVisible: p,
    popupClassName: $e(r, pe(pe({}, "".concat(h, "-range"), s), "".concat(h, "-rtl"), m === "rtl")),
    popupStyle: n,
    stretch: "minWidth",
    getPopupContainer: l,
    onPopupVisibleChange: function(y) {
      y || C();
    }
  }, u);
}
function Wn(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", r = String(e); r.length < t; )
    r = "".concat(n).concat(r);
  return r;
}
function ht(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Vt(e, t, n) {
  var r = Be(e);
  return r[t] = n, r;
}
function rn(e, t) {
  var n = {}, r = t || Object.keys(e);
  return r.forEach(function(a) {
    e[a] !== void 0 && (n[a] = e[a]);
  }), n;
}
function Rr(e, t, n) {
  if (n)
    return n;
  switch (e) {
    case "time":
      return t.fieldTimeFormat;
    case "datetime":
      return t.fieldDateTimeFormat;
    case "month":
      return t.fieldMonthFormat;
    case "year":
      return t.fieldYearFormat;
    case "quarter":
      return t.fieldQuarterFormat;
    case "week":
      return t.fieldWeekFormat;
    default:
      return t.fieldDateFormat;
  }
}
function Or(e, t, n) {
  var r = n !== void 0 ? n : t[t.length - 1], a = t.find(function(i) {
    return e[i];
  });
  return r !== a ? e[a] : void 0;
}
function _r(e) {
  return rn(e, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}
function jn(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (Ge(!t, "'dateRender' is deprecated. Please use 'cellRender' instead."), Ge(!n, "'monthCellRender' is deprecated. Please use 'cellRender' instead."));
  var a = o.useMemo(function() {
    return e || function(l, u) {
      var s = l;
      return t && u.type === "date" ? t(s, u.today) : n && u.type === "month" ? n(s, u.locale) : u.originNode;
    };
  }, [e, n, t]), i = o.useCallback(function(l, u) {
    return a(l, ie(ie({}, u), {}, {
      range: r
    }));
  }, [a, r]);
  return i;
}
function Vr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = o.useState([!1, !1]), a = B(r, 2), i = a[0], l = a[1], u = function(c, d) {
    l(function(m) {
      return Vt(m, d, c);
    });
  }, s = o.useMemo(function() {
    return i.map(function(f, c) {
      if (f)
        return !0;
      var d = e[c];
      return d ? !!(!n[c] && !d || d && t(d, {
        activeIndex: c
      })) : !1;
    });
  }, [e, i, t, n]);
  return [s, u];
}
function Hr(e, t, n, r, a) {
  var i = "", l = [];
  return e && l.push(a ? "hh" : "HH"), t && l.push("mm"), n && l.push("ss"), i = l.join(":"), r && (i += ".SSS"), a && (i += " A"), i;
}
function ho(e, t, n, r, a, i) {
  var l = e.fieldDateTimeFormat, u = e.fieldDateFormat, s = e.fieldTimeFormat, f = e.fieldMonthFormat, c = e.fieldYearFormat, d = e.fieldWeekFormat, m = e.fieldQuarterFormat, p = e.yearFormat, C = e.cellYearFormat, S = e.cellQuarterFormat, v = e.dayFormat, h = e.cellDateFormat, M = Hr(t, n, r, a, i);
  return ie(ie({}, e), {}, {
    fieldDateTimeFormat: l || "YYYY-MM-DD ".concat(M),
    fieldDateFormat: u || "YYYY-MM-DD",
    fieldTimeFormat: s || M,
    fieldMonthFormat: f || "YYYY-MM",
    fieldYearFormat: c || "YYYY",
    fieldWeekFormat: d || "gggg-wo",
    fieldQuarterFormat: m || "YYYY-[Q]Q",
    yearFormat: p || "YYYY",
    cellYearFormat: C || "YYYY",
    cellQuarterFormat: S || "[Q]Q",
    cellDateFormat: h || v || "D"
  });
}
function Tr(e, t) {
  var n = t.showHour, r = t.showMinute, a = t.showSecond, i = t.showMillisecond, l = t.use12Hours;
  return Qt.useMemo(function() {
    return ho(e, n, r, a, i, l);
  }, [e, n, r, a, i, l]);
}
function Nt(e, t, n) {
  return n ?? t.some(function(r) {
    return e.includes(r);
  });
}
var po = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function Co(e) {
  var t = rn(e, po), n = e.format, r = e.picker, a = null;
  return n && (a = n, Array.isArray(a) && (a = a[0]), a = Ht(a) === "object" ? a.format : a), r === "time" && (t.format = a), [t, a];
}
function bo(e) {
  return e && typeof e == "string";
}
function Fr(e, t, n, r) {
  return [e, t, n, r].some(function(a) {
    return a !== void 0;
  });
}
function Yr(e, t, n, r, a) {
  var i = t, l = n, u = r;
  if (!e && !i && !l && !u && !a)
    i = !0, l = !0, u = !0;
  else if (e) {
    var s, f, c, d = [i, l, u].some(function(C) {
      return C === !1;
    }), m = [i, l, u].some(function(C) {
      return C === !0;
    }), p = d ? !0 : !m;
    i = (s = i) !== null && s !== void 0 ? s : p, l = (f = l) !== null && f !== void 0 ? f : p, u = (c = u) !== null && c !== void 0 ? c : p;
  }
  return [i, l, u, a];
}
function Ar(e) {
  var t = e.showTime, n = Co(e), r = B(n, 2), a = r[0], i = r[1], l = t && Ht(t) === "object" ? t : {}, u = ie(ie({
    defaultOpenValue: l.defaultOpenValue || l.defaultValue
  }, a), l), s = u.showMillisecond, f = u.showHour, c = u.showMinute, d = u.showSecond, m = Fr(f, c, d, s), p = Yr(m, f, c, d, s), C = B(p, 3);
  return f = C[0], c = C[1], d = C[2], [u, ie(ie({}, u), {}, {
    showHour: f,
    showMinute: c,
    showSecond: d,
    showMillisecond: s
  }), u.format, i];
}
function Lr(e, t, n, r, a) {
  var i = e === "time";
  if (e === "datetime" || i) {
    for (var l = r, u = Rr(e, a, null), s = u, f = [t, n], c = 0; c < f.length; c += 1) {
      var d = ht(f[c])[0];
      if (bo(d)) {
        s = d;
        break;
      }
    }
    var m = l.showHour, p = l.showMinute, C = l.showSecond, S = l.showMillisecond, v = l.use12Hours, h = Nt(s, ["a", "A", "LT", "LLL", "LTS"], v), M = Fr(m, p, C, S);
    M || (m = Nt(s, ["H", "h", "k", "LT", "LLL"]), p = Nt(s, ["m", "LT", "LLL"]), C = Nt(s, ["s", "LTS"]), S = Nt(s, ["SSS"]));
    var k = Yr(M, m, p, C, S), y = B(k, 3);
    m = y[0], p = y[1], C = y[2];
    var I = t || Hr(m, p, C, S, h);
    return ie(ie({}, l), {}, {
      // Format
      format: I,
      // Show Config
      showHour: m,
      showMinute: p,
      showSecond: C,
      showMillisecond: S,
      use12Hours: h
    });
  }
  return null;
}
function So(e, t, n) {
  if (process.env.NODE_ENV !== "production" && n && Ge(!1, "`clearIcon` will be removed in future. Please use `allowClear` instead."), t === !1)
    return null;
  var r = t && Ht(t) === "object" ? t : {};
  return r.clearIcon || n || /* @__PURE__ */ o.createElement("span", {
    className: "".concat(e, "-clear-btn")
  });
}
var Nn = 7;
function ut(e, t, n) {
  return !e && !t || e === t ? !0 : !e || !t ? !1 : n();
}
function Tn(e, t, n) {
  return ut(t, n, function() {
    var r = Math.floor(e.getYear(t) / 10), a = Math.floor(e.getYear(n) / 10);
    return r === a;
  });
}
function vt(e, t, n) {
  return ut(t, n, function() {
    return e.getYear(t) === e.getYear(n);
  });
}
function er(e, t) {
  var n = Math.floor(e.getMonth(t) / 3);
  return n + 1;
}
function yo(e, t, n) {
  return ut(t, n, function() {
    return vt(e, t, n) && er(e, t) === er(e, n);
  });
}
function zn(e, t, n) {
  return ut(t, n, function() {
    return vt(e, t, n) && e.getMonth(t) === e.getMonth(n);
  });
}
function Un(e, t, n) {
  return ut(t, n, function() {
    return vt(e, t, n) && zn(e, t, n) && e.getDate(t) === e.getDate(n);
  });
}
function Br(e, t, n) {
  return ut(t, n, function() {
    return e.getHour(t) === e.getHour(n) && e.getMinute(t) === e.getMinute(n) && e.getSecond(t) === e.getSecond(n);
  });
}
function Wr(e, t, n) {
  return ut(t, n, function() {
    return Un(e, t, n) && Br(e, t, n) && e.getMillisecond(t) === e.getMillisecond(n);
  });
}
function Ot(e, t, n, r) {
  return ut(n, r, function() {
    var a = e.locale.getWeekFirstDate(t, n), i = e.locale.getWeekFirstDate(t, r);
    return vt(e, a, i) && e.locale.getWeek(t, n) === e.locale.getWeek(t, r);
  });
}
function Le(e, t, n, r, a) {
  switch (a) {
    case "date":
      return Un(e, n, r);
    case "week":
      return Ot(e, t.locale, n, r);
    case "month":
      return zn(e, n, r);
    case "quarter":
      return yo(e, n, r);
    case "year":
      return vt(e, n, r);
    case "decade":
      return Tn(e, n, r);
    case "time":
      return Br(e, n, r);
    default:
      return Wr(e, n, r);
  }
}
function an(e, t, n, r) {
  return !t || !n || !r ? !1 : e.isAfter(r, t) && e.isAfter(n, r);
}
function zt(e, t, n, r, a) {
  return Le(e, t, n, r, a) ? !0 : e.isAfter(n, r);
}
function xo(e, t, n) {
  var r = t.locale.getWeekFirstDay(e), a = t.setDate(n, 1), i = t.getWeekDay(a), l = t.addDate(a, r - i);
  return t.getMonth(l) === t.getMonth(n) && t.getDate(l) > 1 && (l = t.addDate(l, -7)), l;
}
function _e(e, t) {
  var n = t.generateConfig, r = t.locale, a = t.format;
  return e ? typeof a == "function" ? a(e) : n.locale.format(r.locale, e, a) : "";
}
function tn(e, t, n) {
  var r = t, a = ["getHour", "getMinute", "getSecond", "getMillisecond"], i = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  return i.forEach(function(l, u) {
    n ? r = e[l](r, e[a[u]](n)) : r = e[l](r, 0);
  }), r;
}
function ko(e, t, n, r, a) {
  var i = Ye(function(l, u) {
    return !!(n && n(l, u) || r && e.isAfter(r, l) && !Le(e, t, r, l, u.type) || a && e.isAfter(l, a) && !Le(e, t, a, l, u.type));
  });
  return i;
}
function wo(e, t, n) {
  return o.useMemo(function() {
    var r = Rr(e, t, n), a = ht(r), i = a[0], l = Ht(i) === "object" && i.type === "mask" ? i.format : null;
    return [
      // Format list
      a.map(function(u) {
        return typeof u == "string" || typeof u == "function" ? u : u.format;
      }),
      // Mask Format
      l
    ];
  }, [e, t, n]);
}
function Mo(e, t, n) {
  return typeof e[0] == "function" || n ? !0 : t;
}
function $o(e, t, n, r) {
  var a = Ye(function(i, l) {
    var u = ie({
      type: t
    }, l);
    if (delete u.activeIndex, // Date object is invalid
    !e.isValidate(i) || // Date is disabled by `disabledDate`
    n && n(i, u))
      return !0;
    if ((t === "date" || t === "time") && r) {
      var s, f = l && l.activeIndex === 1 ? "end" : "start", c = ((s = r.disabledTime) === null || s === void 0 ? void 0 : s.call(r, i, f, {
        from: u.from
      })) || {}, d = c.disabledHours, m = c.disabledMinutes, p = c.disabledSeconds, C = c.disabledMilliseconds, S = r.disabledHours, v = r.disabledMinutes, h = r.disabledSeconds, M = d || S, k = m || v, y = p || h, I = e.getHour(i), P = e.getMinute(i), E = e.getSecond(i), L = e.getMillisecond(i);
      if (M && M().includes(I) || k && k(I).includes(P) || y && y(I, P).includes(E) || C && C(I, P, E).includes(L))
        return !0;
    }
    return !1;
  });
  return a;
}
function Ut(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = o.useMemo(function() {
    var r = e && ht(e);
    return t && r && (r[1] = r[1] || r[0]), r;
  }, [e, t]);
  return n;
}
function jr(e, t) {
  var n = e.generateConfig, r = e.locale, a = e.picker, i = a === void 0 ? "date" : a, l = e.prefixCls, u = l === void 0 ? "rc-picker" : l, s = e.styles, f = s === void 0 ? {} : s, c = e.classNames, d = c === void 0 ? {} : c, m = e.order, p = m === void 0 ? !0 : m, C = e.components, S = C === void 0 ? {} : C, v = e.inputRender, h = e.allowClear, M = e.clearIcon, k = e.needConfirm, y = e.multiple, I = e.format, P = e.inputReadOnly, E = e.disabledDate, L = e.minDate, Y = e.maxDate, O = e.showTime, V = e.value, A = e.defaultValue, T = e.pickerValue, x = e.defaultPickerValue, g = Ut(V), b = Ut(A), $ = Ut(T), w = Ut(x), H = i === "date" && O ? "datetime" : i, R = H === "time" || H === "datetime", N = R || y, D = k ?? R, _ = Ar(e), F = B(_, 4), q = F[0], X = F[1], z = F[2], Q = F[3], K = Tr(r, X), W = o.useMemo(function() {
    return Lr(H, z, Q, q, K);
  }, [H, z, Q, q, K]);
  process.env.NODE_ENV !== "production" && i === "time" && ["disabledHours", "disabledMinutes", "disabledSeconds"].some(function(fe) {
    return e[fe];
  }) && Ge(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
  var U = o.useMemo(function() {
    return ie(ie({}, e), {}, {
      prefixCls: u,
      locale: K,
      picker: i,
      styles: f,
      classNames: d,
      order: p,
      components: ie({
        input: v
      }, S),
      clearIcon: So(u, h, M),
      showTime: W,
      value: g,
      defaultValue: b,
      pickerValue: $,
      defaultPickerValue: w
    }, t == null ? void 0 : t());
  }, [e]), re = wo(H, K, I), te = B(re, 2), le = te[0], ge = te[1], J = Mo(le, P, y), Ce = ko(n, r, E, L, Y), ue = $o(n, i, Ce, W), xe = o.useMemo(function() {
    return ie(ie({}, U), {}, {
      needConfirm: D,
      inputReadOnly: J,
      disabledDate: Ce
    });
  }, [U, D, J, Ce]);
  return [xe, H, N, le, ge, ue];
}
function Do(e, t, n) {
  var r = rt(t, {
    value: e
  }), a = B(r, 2), i = a[0], l = a[1], u = Qt.useRef(e), s = Qt.useRef(), f = function() {
    nt.cancel(s.current);
  }, c = Ye(function() {
    l(u.current), n && i !== u.current && n(u.current);
  }), d = Ye(function(m, p) {
    f(), u.current = m, m || p ? c() : s.current = nt(c);
  });
  return Qt.useEffect(function() {
    return f;
  }, []), [i, d];
}
function zr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 ? arguments[3] : void 0, a = n.every(function(c) {
    return c;
  }) ? !1 : e, i = Do(a, t || !1, r), l = B(i, 2), u = l[0], s = l[1];
  function f(c) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (!d.inherit || u) && s(c, d.force);
  }
  return [u, f];
}
function Ur(e) {
  var t = o.useRef();
  return o.useImperativeHandle(e, function() {
    var n;
    return {
      nativeElement: (n = t.current) === null || n === void 0 ? void 0 : n.nativeElement,
      focus: function(a) {
        var i;
        (i = t.current) === null || i === void 0 || i.focus(a);
      },
      blur: function() {
        var a;
        (a = t.current) === null || a === void 0 || a.blur();
      }
    };
  }), t;
}
function qr(e, t) {
  return o.useMemo(function() {
    return e || (t ? (Ge(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(t).map(function(n) {
      var r = B(n, 2), a = r[0], i = r[1];
      return {
        label: a,
        value: i
      };
    })) : []);
  }, [e, t]);
}
function qn(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = o.useRef(t);
  r.current = t, Ma(function() {
    if (e)
      r.current(e);
    else {
      var a = nt(function() {
        r.current(e);
      }, n);
      return function() {
        nt.cancel(a);
      };
    }
  }, [e]);
}
function Kr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = o.useState(0), a = B(r, 2), i = a[0], l = a[1], u = o.useState(!1), s = B(u, 2), f = s[0], c = s[1], d = o.useRef([]), m = o.useRef(null), p = o.useRef(null), C = function(y) {
    m.current = y;
  }, S = function(y) {
    return m.current === y;
  }, v = function(y) {
    c(y);
  }, h = function(y) {
    return y && (p.current = y), p.current;
  }, M = function(y) {
    var I = d.current, P = new Set(I.filter(function(L) {
      return y[L] || t[L];
    })), E = I[I.length - 1] === 0 ? 1 : 0;
    return P.size >= 2 || e[E] ? null : E;
  };
  return qn(f || n, function() {
    f || (d.current = [], C(null));
  }), o.useEffect(function() {
    f && d.current.push(i);
  }, [f, i]), [f, v, h, i, l, M, d.current, C, S];
}
function Po(e, t, n, r, a, i) {
  var l = n[n.length - 1], u = function(f, c) {
    var d = B(e, 2), m = d[0], p = d[1], C = ie(ie({}, c), {}, {
      from: Or(e, n)
    });
    return l === 1 && t[0] && m && // Same date isOK
    !Le(r, a, m, f, C.type) && // Before start date
    r.isAfter(m, f) || l === 0 && t[1] && p && // Same date isOK
    !Le(r, a, p, f, C.type) && // After end date
    r.isAfter(f, p) ? !0 : i == null ? void 0 : i(f, C);
  };
  return u;
}
function _t(e, t, n, r) {
  switch (t) {
    case "date":
    case "week":
      return e.addMonth(n, r);
    case "month":
    case "quarter":
      return e.addYear(n, r);
    case "year":
      return e.addYear(n, r * 10);
    case "decade":
      return e.addYear(n, r * 100);
    default:
      return n;
  }
}
var Rn = [];
function Gr(e, t, n, r, a, i, l, u) {
  var s = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : Rn, f = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : Rn, c = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : Rn, d = arguments.length > 11 ? arguments[11] : void 0, m = arguments.length > 12 ? arguments[12] : void 0, p = arguments.length > 13 ? arguments[13] : void 0, C = l === "time", S = i || 0, v = function($) {
    var w = e.getNow();
    return C && (w = tn(e, w)), s[$] || n[$] || w;
  }, h = B(f, 2), M = h[0], k = h[1], y = rt(function() {
    return v(0);
  }, {
    value: M
  }), I = B(y, 2), P = I[0], E = I[1], L = rt(function() {
    return v(1);
  }, {
    value: k
  }), Y = B(L, 2), O = Y[0], V = Y[1], A = o.useMemo(function() {
    var b = [P, O][S];
    return C ? b : tn(e, b, c[S]);
  }, [C, P, O, S, e, c]), T = function($) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel", H = [E, V][S];
    H($);
    var R = [P, O];
    R[S] = $, d && (!Le(e, t, P, R[0], l) || !Le(e, t, O, R[1], l)) && d(R, {
      source: w,
      range: S === 1 ? "end" : "start",
      mode: r
    });
  }, x = function($, w) {
    if (u) {
      var H = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      }, R = H[l];
      if (R && !Le(e, t, $, w, R))
        return _t(e, l, w, -1);
      if (l === "year" && $) {
        var N = Math.floor(e.getYear($) / 10), D = Math.floor(e.getYear(w) / 10);
        if (N !== D)
          return _t(e, l, w, -1);
      }
    }
    return w;
  }, g = o.useRef(null);
  return lt(function() {
    if (a && !s[S]) {
      var b = C ? null : e.getNow();
      if (g.current !== null && g.current !== S ? b = [P, O][S ^ 1] : n[S] ? b = S === 0 ? n[0] : x(n[0], n[1]) : n[S ^ 1] && (b = n[S ^ 1]), b) {
        m && e.isAfter(m, b) && (b = m);
        var $ = u ? _t(e, l, b, 1) : b;
        p && e.isAfter($, p) && (b = u ? _t(e, l, p, -1) : p), T(b, "reset");
      }
    }
  }, [a, S, n[S]]), o.useEffect(function() {
    a ? g.current = S : g.current = null;
  }, [a, S]), lt(function() {
    a && s && s[S] && T(s[S], "reset");
  }, [a, S]), [A, T];
}
function Xr(e, t) {
  var n = o.useRef(e), r = o.useState({}), a = B(r, 2), i = a[1], l = function(f) {
    return f && t !== void 0 ? t : n.current;
  }, u = function(f) {
    n.current = f, i({});
  };
  return [l, u, l(!0)];
}
var Io = [];
function Qr(e, t, n) {
  var r = function(l) {
    return l.map(function(u) {
      return _e(u, {
        generateConfig: e,
        locale: t,
        format: n[0]
      });
    });
  }, a = function(l, u) {
    for (var s = Math.max(l.length, u.length), f = -1, c = 0; c < s; c += 1) {
      var d = l[c] || null, m = u[c] || null;
      if (d !== m && !Wr(e, d, m)) {
        f = c;
        break;
      }
    }
    return [f < 0, f !== 0];
  };
  return [r, a];
}
function Zr(e, t) {
  return Be(e).sort(function(n, r) {
    return t.isAfter(n, r) ? 1 : -1;
  });
}
function Eo(e) {
  var t = Xr(e), n = B(t, 2), r = n[0], a = n[1], i = Ye(function() {
    a(e);
  });
  return o.useEffect(function() {
    i();
  }, [e]), [r, a];
}
function Jr(e, t, n, r, a, i, l, u, s) {
  var f = rt(i, {
    value: l
  }), c = B(f, 2), d = c[0], m = c[1], p = d || Io, C = Eo(p), S = B(C, 2), v = S[0], h = S[1], M = Qr(e, t, n), k = B(M, 2), y = k[0], I = k[1], P = Ye(function(L) {
    var Y = Be(L);
    if (r)
      for (var O = 0; O < 2; O += 1)
        Y[O] = Y[O] || null;
    else a && (Y = Zr(Y.filter(function(b) {
      return b;
    }), e));
    var V = I(v(), Y), A = B(V, 2), T = A[0], x = A[1];
    if (!T && (h(Y), u)) {
      var g = y(Y);
      u(Y, g, {
        range: x ? "end" : "start"
      });
    }
  }), E = function() {
    s && s(v());
  };
  return [p, m, v, P, E];
}
function ea(e, t, n, r, a, i, l, u, s, f) {
  var c = e.generateConfig, d = e.locale, m = e.picker, p = e.onChange, C = e.allowEmpty, S = e.order, v = i.some(function(T) {
    return T;
  }) ? !1 : S, h = Qr(c, d, l), M = B(h, 2), k = M[0], y = M[1], I = Xr(t), P = B(I, 2), E = P[0], L = P[1], Y = Ye(function() {
    L(t);
  });
  o.useEffect(function() {
    Y();
  }, [t]);
  var O = Ye(function(T) {
    var x = T === null, g = Be(T || E());
    if (x)
      for (var b = Math.max(i.length, g.length), $ = 0; $ < b; $ += 1)
        i[$] || (g[$] = null);
    v && g[0] && g[1] && (g = Zr(g, c)), a(g);
    var w = g, H = B(w, 2), R = H[0], N = H[1], D = !R, _ = !N, F = C ? (
      // Validate empty start
      (!D || C[0]) && // Validate empty end
      (!_ || C[1])
    ) : !0, q = !S || D || _ || Le(c, d, R, N, m) || c.isAfter(N, R), X = (
      // Validate start
      (i[0] || !R || !f(R, {
        activeIndex: 0
      })) && // Validate end
      (i[1] || !N || !f(N, {
        from: R,
        activeIndex: 1
      }))
    ), z = (
      // Null value is from clear button
      x || // Normal check
      F && q && X
    );
    if (z) {
      n(g);
      var Q = y(g, t), K = B(Q, 1), W = K[0];
      p && !W && p(
        // Return null directly if all date are empty
        x && g.every(function(U) {
          return !U;
        }) ? null : g,
        k(g)
      );
    }
    return z;
  }), V = Ye(function(T, x) {
    var g = Vt(E(), T, r()[T]);
    L(g), x && O();
  }), A = !u && !s;
  return qn(!A, function() {
    A && (O(), a(t), Y());
  }, 2), [V, O];
}
function ta(e, t, n, r, a) {
  return t !== "date" && t !== "time" ? !1 : n !== void 0 ? n : r !== void 0 ? r : !a && (e === "date" || e === "time");
}
function No(e, t, n, r, a, i) {
  var l = e;
  function u(d, m, p) {
    var C = i[d](l), S = p.find(function(k) {
      return k.value === C;
    });
    if (!S || S.disabled) {
      var v = p.filter(function(k) {
        return !k.disabled;
      }), h = Be(v).reverse(), M = h.find(function(k) {
        return k.value <= C;
      }) || v[0];
      M && (C = M.value, l = i[m](l, C));
    }
    return C;
  }
  var s = u("getHour", "setHour", t()), f = u("getMinute", "setMinute", n(s)), c = u("getSecond", "setSecond", r(s, f));
  return u("getMillisecond", "setMillisecond", a(s, f, c)), l;
}
function qt() {
  return [];
}
function Kt(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2, l = [], u = n >= 1 ? n | 0 : 1, s = e; s <= t; s += u) {
    var f = a.includes(s);
    (!f || !r) && l.push({
      label: Wn(s, i),
      value: s,
      disabled: f
    });
  }
  return l;
}
function Kn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = t || {}, a = r.use12Hours, i = r.hourStep, l = i === void 0 ? 1 : i, u = r.minuteStep, s = u === void 0 ? 1 : u, f = r.secondStep, c = f === void 0 ? 1 : f, d = r.millisecondStep, m = d === void 0 ? 100 : d, p = r.hideDisabledOptions, C = r.disabledTime, S = r.disabledHours, v = r.disabledMinutes, h = r.disabledSeconds, M = o.useMemo(function() {
    return n || e.getNow();
  }, [n, e]);
  if (process.env.NODE_ENV !== "production") {
    var k = 24 % l === 0, y = 60 % s === 0, I = 60 % c === 0;
    Ge(k, "`hourStep` ".concat(l, " is invalid. It should be a factor of 24.")), Ge(y, "`minuteStep` ".concat(s, " is invalid. It should be a factor of 60.")), Ge(I, "`secondStep` ".concat(c, " is invalid. It should be a factor of 60."));
  }
  var P = o.useCallback(function(N) {
    var D = (C == null ? void 0 : C(N)) || {};
    return [D.disabledHours || S || qt, D.disabledMinutes || v || qt, D.disabledSeconds || h || qt, D.disabledMilliseconds || qt];
  }, [C, S, v, h]), E = o.useMemo(function() {
    return P(M);
  }, [M, P]), L = B(E, 4), Y = L[0], O = L[1], V = L[2], A = L[3], T = o.useCallback(function(N, D, _, F) {
    var q = Kt(0, 23, l, p, N()), X = a ? q.map(function(W) {
      return ie(ie({}, W), {}, {
        label: Wn(W.value % 12 || 12, 2)
      });
    }) : q, z = function(U) {
      return Kt(0, 59, s, p, D(U));
    }, Q = function(U, re) {
      return Kt(0, 59, c, p, _(U, re));
    }, K = function(U, re, te) {
      return Kt(0, 999, m, p, F(U, re, te), 3);
    };
    return [X, z, Q, K];
  }, [p, l, a, m, s, c]), x = o.useMemo(function() {
    return T(Y, O, V, A);
  }, [T, Y, O, V, A]), g = B(x, 4), b = g[0], $ = g[1], w = g[2], H = g[3], R = function(D, _) {
    var F = function() {
      return b;
    }, q = $, X = w, z = H;
    if (_) {
      var Q = P(_), K = B(Q, 4), W = K[0], U = K[1], re = K[2], te = K[3], le = T(W, U, re, te), ge = B(le, 4), J = ge[0], Ce = ge[1], ue = ge[2], xe = ge[3];
      F = function() {
        return J;
      }, q = Ce, X = ue, z = xe;
    }
    var fe = No(D, F, q, X, z, e);
    return fe;
  };
  return [
    // getValidTime
    R,
    // Units
    b,
    $,
    w,
    H
  ];
}
function Ro(e) {
  var t = e.mode, n = e.internalMode, r = e.renderExtraFooter, a = e.showNow, i = e.showTime, l = e.onSubmit, u = e.onNow, s = e.invalid, f = e.needConfirm, c = e.generateConfig, d = e.disabledDate, m = o.useContext(Xe), p = m.prefixCls, C = m.locale, S = m.button, v = S === void 0 ? "button" : S, h = c.getNow(), M = Kn(c, i, h), k = B(M, 1), y = k[0], I = r == null ? void 0 : r(t), P = d(h, {
    type: t
  }), E = function() {
    if (!P) {
      var x = y(h);
      u(x);
    }
  }, L = "".concat(p, "-now"), Y = "".concat(L, "-btn"), O = a && /* @__PURE__ */ o.createElement("li", {
    className: L
  }, /* @__PURE__ */ o.createElement("a", {
    className: $e(Y, P && "".concat(Y, "-disabled")),
    "aria-disabled": P,
    onClick: E
  }, n === "date" ? C.today : C.now)), V = f && /* @__PURE__ */ o.createElement("li", {
    className: "".concat(p, "-ok")
  }, /* @__PURE__ */ o.createElement(v, {
    disabled: s,
    onClick: l
  }, C.ok)), A = (O || V) && /* @__PURE__ */ o.createElement("ul", {
    className: "".concat(p, "-ranges")
  }, O, V);
  return !I && !A ? null : /* @__PURE__ */ o.createElement("div", {
    className: "".concat(p, "-footer")
  }, I && /* @__PURE__ */ o.createElement("div", {
    className: "".concat(p, "-footer-extra")
  }, I), A);
}
function na(e, t, n) {
  function r(a, i) {
    var l = a.findIndex(function(s) {
      return Le(e, t, s, i, n);
    });
    if (l === -1)
      return [].concat(Be(a), [i]);
    var u = Be(a);
    return u.splice(l, 1), u;
  }
  return r;
}
var pt = /* @__PURE__ */ o.createContext(null);
function on() {
  return o.useContext(pt);
}
function kt(e, t) {
  var n = e.prefixCls, r = e.generateConfig, a = e.locale, i = e.disabledDate, l = e.minDate, u = e.maxDate, s = e.cellRender, f = e.hoverValue, c = e.hoverRangeValue, d = e.onHover, m = e.values, p = e.pickerValue, C = e.onSelect, S = e.prevIcon, v = e.nextIcon, h = e.superPrevIcon, M = e.superNextIcon, k = r.getNow(), y = {
    now: k,
    values: m,
    pickerValue: p,
    prefixCls: n,
    disabledDate: i,
    minDate: l,
    maxDate: u,
    cellRender: s,
    hoverValue: f,
    hoverRangeValue: c,
    onHover: d,
    locale: a,
    generateConfig: r,
    onSelect: C,
    panelType: t,
    // Icons
    prevIcon: S,
    nextIcon: v,
    superPrevIcon: h,
    superNextIcon: M
  };
  return [y, k];
}
var at = /* @__PURE__ */ o.createContext({});
process.env.NODE_ENV !== "production" && (at.displayName = "PickerHackContext");
function Tt(e) {
  for (var t = e.rowNum, n = e.colNum, r = e.baseDate, a = e.getCellDate, i = e.prefixColumn, l = e.rowClassName, u = e.titleFormat, s = e.getCellText, f = e.getCellClassName, c = e.headerCells, d = e.cellSelection, m = d === void 0 ? !0 : d, p = e.disabledDate, C = on(), S = C.prefixCls, v = C.panelType, h = C.now, M = C.disabledDate, k = C.cellRender, y = C.onHover, I = C.hoverValue, P = C.hoverRangeValue, E = C.generateConfig, L = C.values, Y = C.locale, O = C.onSelect, V = p || M, A = "".concat(S, "-cell"), T = o.useContext(at), x = T.onCellDblClick, g = function(_) {
    return L.some(function(F) {
      return F && Le(E, Y, _, F, v);
    });
  }, b = [], $ = 0; $ < t; $ += 1) {
    for (var w = [], H = void 0, R = function() {
      var _ = $ * n + N, F = a(r, _), q = V == null ? void 0 : V(F, {
        type: v
      });
      N === 0 && (H = F, i && w.push(i(H)));
      var X = !1, z = !1, Q = !1;
      if (m && P) {
        var K = B(P, 2), W = K[0], U = K[1];
        X = an(E, W, U, F), z = Le(E, Y, F, W, v), Q = Le(E, Y, F, U, v);
      }
      var re = u ? _e(F, {
        locale: Y,
        format: u,
        generateConfig: E
      }) : void 0, te = /* @__PURE__ */ o.createElement("div", {
        className: "".concat(A, "-inner")
      }, s(F));
      w.push(/* @__PURE__ */ o.createElement("td", {
        key: N,
        title: re,
        className: $e(A, ie(pe(pe(pe(pe(pe(pe({}, "".concat(A, "-disabled"), q), "".concat(A, "-hover"), (I || []).some(function(le) {
          return Le(E, Y, F, le, v);
        })), "".concat(A, "-in-range"), X && !z && !Q), "".concat(A, "-range-start"), z), "".concat(A, "-range-end"), Q), "".concat(S, "-cell-selected"), !P && // WeekPicker use row instead
        v !== "week" && g(F)), f(F))),
        onClick: function() {
          q || O(F);
        },
        onDoubleClick: function() {
          !q && x && x();
        },
        onMouseEnter: function() {
          q || y == null || y(F);
        },
        onMouseLeave: function() {
          q || y == null || y(null);
        }
      }, k ? k(F, {
        prefixCls: S,
        originNode: te,
        today: h,
        type: v,
        locale: Y
      }) : te));
    }, N = 0; N < n; N += 1)
      R();
    b.push(/* @__PURE__ */ o.createElement("tr", {
      key: $,
      className: l == null ? void 0 : l(H)
    }, w));
  }
  return /* @__PURE__ */ o.createElement("div", {
    className: "".concat(S, "-body")
  }, /* @__PURE__ */ o.createElement("table", {
    className: "".concat(S, "-content")
  }, c && /* @__PURE__ */ o.createElement("thead", null, /* @__PURE__ */ o.createElement("tr", null, c)), /* @__PURE__ */ o.createElement("tbody", null, b)));
}
var Gt = {
  visibility: "hidden"
};
function wt(e) {
  var t = e.offset, n = e.superOffset, r = e.onChange, a = e.getStart, i = e.getEnd, l = e.children, u = on(), s = u.prefixCls, f = u.prevIcon, c = f === void 0 ? "‹" : f, d = u.nextIcon, m = d === void 0 ? "›" : d, p = u.superPrevIcon, C = p === void 0 ? "«" : p, S = u.superNextIcon, v = S === void 0 ? "»" : S, h = u.minDate, M = u.maxDate, k = u.generateConfig, y = u.locale, I = u.pickerValue, P = u.panelType, E = "".concat(s, "-header"), L = o.useContext(at), Y = L.hidePrev, O = L.hideNext, V = L.hideHeader, A = o.useMemo(function() {
    if (!h || !t || !i)
      return !1;
    var D = i(t(-1, I));
    return !zt(k, y, D, h, P);
  }, [h, t, I, i, k, y, P]), T = o.useMemo(function() {
    if (!h || !n || !i)
      return !1;
    var D = i(n(-1, I));
    return !zt(k, y, D, h, P);
  }, [h, n, I, i, k, y, P]), x = o.useMemo(function() {
    if (!M || !t || !a)
      return !1;
    var D = a(t(1, I));
    return !zt(k, y, M, D, P);
  }, [M, t, I, a, k, y, P]), g = o.useMemo(function() {
    if (!M || !n || !a)
      return !1;
    var D = a(n(1, I));
    return !zt(k, y, M, D, P);
  }, [M, n, I, a, k, y, P]), b = function(_) {
    t && r(t(_, I));
  }, $ = function(_) {
    n && r(n(_, I));
  };
  if (V)
    return null;
  var w = "".concat(E, "-prev-btn"), H = "".concat(E, "-next-btn"), R = "".concat(E, "-super-prev-btn"), N = "".concat(E, "-super-next-btn");
  return /* @__PURE__ */ o.createElement("div", {
    className: E
  }, n && /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": y.previousYear,
    onClick: function() {
      return $(-1);
    },
    tabIndex: -1,
    className: $e(R, T && "".concat(R, "-disabled")),
    disabled: T,
    style: Y ? Gt : {}
  }, C), t && /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": y.previousMonth,
    onClick: function() {
      return b(-1);
    },
    tabIndex: -1,
    className: $e(w, A && "".concat(w, "-disabled")),
    disabled: A,
    style: Y ? Gt : {}
  }, c), /* @__PURE__ */ o.createElement("div", {
    className: "".concat(E, "-view")
  }, l), t && /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": y.nextMonth,
    onClick: function() {
      return b(1);
    },
    tabIndex: -1,
    className: $e(H, x && "".concat(H, "-disabled")),
    disabled: x,
    style: O ? Gt : {}
  }, m), n && /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": y.nextYear,
    onClick: function() {
      return $(1);
    },
    tabIndex: -1,
    className: $e(N, g && "".concat(N, "-disabled")),
    disabled: g,
    style: O ? Gt : {}
  }, v));
}
function ln(e) {
  var t = e.prefixCls, n = e.panelName, r = n === void 0 ? "date" : n, a = e.locale, i = e.generateConfig, l = e.pickerValue, u = e.onPickerValueChange, s = e.onModeChange, f = e.mode, c = f === void 0 ? "date" : f, d = e.disabledDate, m = e.onSelect, p = e.onHover, C = e.showWeek, S = "".concat(t, "-").concat(r, "-panel"), v = "".concat(t, "-cell"), h = c === "week", M = kt(e, c), k = B(M, 2), y = k[0], I = k[1], P = i.locale.getWeekFirstDay(a.locale), E = i.setDate(l, 1), L = xo(a.locale, i, E), Y = i.getMonth(l), O = C === void 0 ? h : C, V = O ? function(D) {
    var _ = d == null ? void 0 : d(D, {
      type: "week"
    });
    return /* @__PURE__ */ o.createElement("td", {
      key: "week",
      className: $e(v, "".concat(v, "-week"), pe({}, "".concat(v, "-disabled"), _)),
      onClick: function() {
        _ || m(D);
      },
      onMouseEnter: function() {
        _ || p == null || p(D);
      },
      onMouseLeave: function() {
        _ || p == null || p(null);
      }
    }, /* @__PURE__ */ o.createElement("div", {
      className: "".concat(v, "-inner")
    }, i.locale.getWeek(a.locale, D)));
  } : null, A = [], T = a.shortWeekDays || (i.locale.getShortWeekDays ? i.locale.getShortWeekDays(a.locale) : []);
  V && A.push(/* @__PURE__ */ o.createElement("th", {
    key: "empty"
  }, /* @__PURE__ */ o.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, a.week)));
  for (var x = 0; x < Nn; x += 1)
    A.push(/* @__PURE__ */ o.createElement("th", {
      key: x
    }, T[(x + P) % Nn]));
  var g = function(_, F) {
    return i.addDate(_, F);
  }, b = function(_) {
    return _e(_, {
      locale: a,
      format: a.cellDateFormat,
      generateConfig: i
    });
  }, $ = function(_) {
    var F = pe(pe({}, "".concat(t, "-cell-in-view"), zn(i, _, l)), "".concat(t, "-cell-today"), Un(i, _, I));
    return F;
  }, w = a.shortMonths || (i.locale.getShortMonths ? i.locale.getShortMonths(a.locale) : []), H = /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": a.yearSelect,
    key: "year",
    onClick: function() {
      s("year", l);
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, _e(l, {
    locale: a,
    format: a.yearFormat,
    generateConfig: i
  })), R = /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": a.monthSelect,
    key: "month",
    onClick: function() {
      s("month", l);
    },
    tabIndex: -1,
    className: "".concat(t, "-month-btn")
  }, a.monthFormat ? _e(l, {
    locale: a,
    format: a.monthFormat,
    generateConfig: i
  }) : w[Y]), N = a.monthBeforeYear ? [R, H] : [H, R];
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: y
  }, /* @__PURE__ */ o.createElement("div", {
    className: $e(S, C && "".concat(S, "-show-week"))
  }, /* @__PURE__ */ o.createElement(wt, {
    offset: function(_) {
      return i.addMonth(l, _);
    },
    superOffset: function(_) {
      return i.addYear(l, _);
    },
    onChange: u,
    getStart: function(_) {
      return i.setDate(_, 1);
    },
    getEnd: function(_) {
      var F = i.setDate(_, 1);
      return F = i.addMonth(F, 1), i.addDate(F, -1);
    }
  }, N), /* @__PURE__ */ o.createElement(Tt, Se({
    titleFormat: a.fieldDateFormat
  }, e, {
    colNum: Nn,
    rowNum: 6,
    baseDate: L,
    headerCells: A,
    getCellDate: g,
    getCellText: b,
    getCellClassName: $,
    prefixColumn: V,
    cellSelection: !h
  }))));
}
var Oo = 1 / 3;
function _o(e, t) {
  var n = o.useRef(!1), r = o.useRef(null), a = o.useRef(null), i = function() {
    return n.current;
  }, l = function() {
    nt.cancel(r.current), n.current = !1;
  }, u = o.useRef(), s = function() {
    var d = e.current;
    if (a.current = null, u.current = 0, d) {
      var m = d.querySelector('[data-value="'.concat(t, '"]')), p = d.querySelector("li"), C = function S() {
        l(), n.current = !0, u.current += 1;
        var v = d.scrollTop, h = p.offsetTop, M = m.offsetTop, k = M - h;
        if (M === 0 && m !== p || !_a(d)) {
          u.current <= 5 && (r.current = nt(S));
          return;
        }
        var y = v + (k - v) * Oo, I = Math.abs(k - y);
        if (a.current !== null && a.current < I) {
          l();
          return;
        }
        if (a.current = I, I <= 1) {
          d.scrollTop = k, l();
          return;
        }
        d.scrollTop = y, r.current = nt(S);
      };
      m && p && C();
    }
  }, f = Ye(s);
  return [f, l, i];
}
var Vo = 300;
function Ho(e) {
  return e.map(function(t) {
    var n = t.value, r = t.label, a = t.disabled;
    return [n, r, a].join(",");
  }).join(";");
}
function Rt(e) {
  var t = e.units, n = e.value, r = e.optionalValue, a = e.type, i = e.onChange, l = e.onHover, u = e.onDblClick, s = e.changeOnScroll, f = on(), c = f.prefixCls, d = f.cellRender, m = f.now, p = f.locale, C = "".concat(c, "-time-panel"), S = "".concat(c, "-time-panel-cell"), v = o.useRef(null), h = o.useRef(), M = function() {
    clearTimeout(h.current);
  }, k = _o(v, n ?? r), y = B(k, 3), I = y[0], P = y[1], E = y[2];
  lt(function() {
    return I(), M(), function() {
      P(), M();
    };
  }, [n, r, Ho(t)]);
  var L = function(V) {
    M();
    var A = V.target;
    !E() && s && (h.current = setTimeout(function() {
      var T = v.current, x = T.querySelector("li").offsetTop, g = Array.from(T.querySelectorAll("li")), b = g.map(function(N) {
        return N.offsetTop - x;
      }), $ = b.map(function(N, D) {
        return t[D].disabled ? Number.MAX_SAFE_INTEGER : Math.abs(N - A.scrollTop);
      }), w = Math.min.apply(Math, Be($)), H = $.findIndex(function(N) {
        return N === w;
      }), R = t[H];
      R && !R.disabled && i(R.value);
    }, Vo));
  }, Y = "".concat(C, "-column");
  return /* @__PURE__ */ o.createElement("ul", {
    className: Y,
    ref: v,
    "data-type": a,
    onScroll: L
  }, t.map(function(O) {
    var V = O.label, A = O.value, T = O.disabled, x = /* @__PURE__ */ o.createElement("div", {
      className: "".concat(S, "-inner")
    }, V);
    return /* @__PURE__ */ o.createElement("li", {
      key: A,
      className: $e(S, pe(pe({}, "".concat(S, "-selected"), n === A), "".concat(S, "-disabled"), T)),
      onClick: function() {
        T || i(A);
      },
      onDoubleClick: function() {
        !T && u && u();
      },
      onMouseEnter: function() {
        l(A);
      },
      onMouseLeave: function() {
        l(null);
      },
      "data-value": A
    }, d ? d(A, {
      prefixCls: c,
      originNode: x,
      today: m,
      type: "time",
      subType: a,
      locale: p
    }) : x);
  }));
}
function it(e) {
  return e < 12;
}
function To(e) {
  var t = e.showHour, n = e.showMinute, r = e.showSecond, a = e.showMillisecond, i = e.use12Hours, l = e.changeOnScroll, u = on(), s = u.prefixCls, f = u.values, c = u.generateConfig, d = u.locale, m = u.onSelect, p = u.onHover, C = p === void 0 ? function() {
  } : p, S = u.pickerValue, v = (f == null ? void 0 : f[0]) || null, h = o.useContext(at), M = h.onCellDblClick, k = Kn(c, e, v), y = B(k, 5), I = y[0], P = y[1], E = y[2], L = y[3], Y = y[4], O = function(Z) {
    var we = v && c[Z](v), Me = S && c[Z](S);
    return [we, Me];
  }, V = O("getHour"), A = B(V, 2), T = A[0], x = A[1], g = O("getMinute"), b = B(g, 2), $ = b[0], w = b[1], H = O("getSecond"), R = B(H, 2), N = R[0], D = R[1], _ = O("getMillisecond"), F = B(_, 2), q = F[0], X = F[1], z = T === null ? null : it(T) ? "am" : "pm", Q = o.useMemo(function() {
    return i ? it(T) ? P.filter(function(j) {
      return it(j.value);
    }) : P.filter(function(j) {
      return !it(j.value);
    }) : P;
  }, [T, P, i]), K = function(Z, we) {
    var Me, Oe = Z.filter(function(qe) {
      return !qe.disabled;
    });
    return we ?? // Fallback to enabled value
    (Oe == null || (Me = Oe[0]) === null || Me === void 0 ? void 0 : Me.value);
  }, W = K(P, T), U = o.useMemo(function() {
    return E(W);
  }, [E, W]), re = K(U, $), te = o.useMemo(function() {
    return L(W, re);
  }, [L, W, re]), le = K(te, N), ge = o.useMemo(function() {
    return Y(W, re, le);
  }, [Y, W, re, le]), J = K(ge, q), Ce = o.useMemo(function() {
    if (!i)
      return [];
    var j = c.getNow(), Z = c.setHour(j, 6), we = c.setHour(j, 18), Me = function(qe, We) {
      var Ke = d.cellMeridiemFormat;
      return Ke ? _e(qe, {
        generateConfig: c,
        locale: d,
        format: Ke
      }) : We;
    };
    return [{
      label: Me(Z, "AM"),
      value: "am",
      disabled: P.every(function(Oe) {
        return Oe.disabled || !it(Oe.value);
      })
    }, {
      label: Me(we, "PM"),
      value: "pm",
      disabled: P.every(function(Oe) {
        return Oe.disabled || it(Oe.value);
      })
    }];
  }, [P, i, c, d]), ue = function(Z) {
    var we = I(Z);
    m(we);
  }, xe = o.useMemo(function() {
    var j = v || S || c.getNow(), Z = function(Me) {
      return Me != null;
    };
    return Z(T) ? (j = c.setHour(j, T), j = c.setMinute(j, $), j = c.setSecond(j, N), j = c.setMillisecond(j, q)) : Z(x) ? (j = c.setHour(j, x), j = c.setMinute(j, w), j = c.setSecond(j, D), j = c.setMillisecond(j, X)) : Z(W) && (j = c.setHour(j, W), j = c.setMinute(j, re), j = c.setSecond(j, le), j = c.setMillisecond(j, J)), j;
  }, [v, S, T, $, N, q, W, re, le, J, x, w, D, X, c]), fe = function(Z, we) {
    return Z === null ? null : c[we](xe, Z);
  }, be = function(Z) {
    return fe(Z, "setHour");
  }, ye = function(Z) {
    return fe(Z, "setMinute");
  }, Ie = function(Z) {
    return fe(Z, "setSecond");
  }, Ee = function(Z) {
    return fe(Z, "setMillisecond");
  }, De = function(Z) {
    return Z === null ? null : Z === "am" && !it(T) ? c.setHour(xe, T - 12) : Z === "pm" && it(T) ? c.setHour(xe, T + 12) : xe;
  }, ve = function(Z) {
    ue(be(Z));
  }, Ve = function(Z) {
    ue(ye(Z));
  }, Ne = function(Z) {
    ue(Ie(Z));
  }, Re = function(Z) {
    ue(Ee(Z));
  }, Te = function(Z) {
    ue(De(Z));
  }, He = function(Z) {
    C(be(Z));
  }, ce = function(Z) {
    C(ye(Z));
  }, ke = function(Z) {
    C(Ie(Z));
  }, G = function(Z) {
    C(Ee(Z));
  }, ee = function(Z) {
    C(De(Z));
  }, ae = {
    onDblClick: M,
    changeOnScroll: l
  };
  return /* @__PURE__ */ o.createElement("div", {
    className: "".concat(s, "-content")
  }, t && /* @__PURE__ */ o.createElement(Rt, Se({
    units: Q,
    value: T,
    optionalValue: x,
    type: "hour",
    onChange: ve,
    onHover: He
  }, ae)), n && /* @__PURE__ */ o.createElement(Rt, Se({
    units: U,
    value: $,
    optionalValue: w,
    type: "minute",
    onChange: Ve,
    onHover: ce
  }, ae)), r && /* @__PURE__ */ o.createElement(Rt, Se({
    units: te,
    value: N,
    optionalValue: D,
    type: "second",
    onChange: Ne,
    onHover: ke
  }, ae)), a && /* @__PURE__ */ o.createElement(Rt, Se({
    units: ge,
    value: q,
    optionalValue: X,
    type: "millisecond",
    onChange: Re,
    onHover: G
  }, ae)), i && /* @__PURE__ */ o.createElement(Rt, Se({
    units: Ce,
    value: z,
    type: "meridiem",
    onChange: Te,
    onHover: ee
  }, ae)));
}
function ra(e) {
  var t = e.prefixCls, n = e.value, r = e.locale, a = e.generateConfig, i = e.showTime, l = i || {}, u = l.format, s = "".concat(t, "-time-panel"), f = kt(e, "time"), c = B(f, 1), d = c[0];
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: d
  }, /* @__PURE__ */ o.createElement("div", {
    className: $e(s)
  }, /* @__PURE__ */ o.createElement(wt, null, n ? _e(n, {
    locale: r,
    format: u,
    generateConfig: a
  }) : " "), /* @__PURE__ */ o.createElement(To, i)));
}
function Fo(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.showTime, a = e.onSelect, i = e.value, l = e.pickerValue, u = e.onHover, s = "".concat(t, "-datetime-panel"), f = Kn(n, r), c = B(f, 1), d = c[0], m = function(v) {
    return i ? tn(n, v, i) : tn(n, v, l);
  }, p = function(v) {
    u == null || u(v && m(v));
  }, C = function(v) {
    var h = m(v);
    a(d(h, h));
  };
  return /* @__PURE__ */ o.createElement("div", {
    className: s
  }, /* @__PURE__ */ o.createElement(ln, Se({}, e, {
    onSelect: C,
    onHover: p
  })), /* @__PURE__ */ o.createElement(ra, e));
}
function Yo(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, a = e.pickerValue, i = e.disabledDate, l = e.onPickerValueChange, u = "".concat(t, "-decade-panel"), s = kt(e, "decade"), f = B(s, 1), c = f[0], d = function(P) {
    var E = Math.floor(r.getYear(P) / 100) * 100;
    return r.setYear(P, E);
  }, m = function(P) {
    var E = d(P);
    return r.addYear(E, 99);
  }, p = d(a), C = m(a), S = r.addYear(p, -10), v = function(P, E) {
    return r.addYear(P, E * 10);
  }, h = function(P) {
    var E = n.cellYearFormat, L = _e(P, {
      locale: n,
      format: E,
      generateConfig: r
    }), Y = _e(r.addYear(P, 9), {
      locale: n,
      format: E,
      generateConfig: r
    });
    return "".concat(L, "-").concat(Y);
  }, M = function(P) {
    return pe({}, "".concat(t, "-cell-in-view"), Tn(r, P, p) || Tn(r, P, C) || an(r, p, C, P));
  }, k = i ? function(I, P) {
    var E = r.setDate(I, 1), L = r.setMonth(E, 0), Y = r.setYear(L, Math.floor(r.getYear(L) / 10) * 10), O = r.addYear(Y, 10), V = r.addDate(O, -1);
    return i(Y, P) && i(V, P);
  } : null, y = "".concat(_e(p, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }), "-").concat(_e(C, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: c
  }, /* @__PURE__ */ o.createElement("div", {
    className: u
  }, /* @__PURE__ */ o.createElement(wt, {
    superOffset: function(P) {
      return r.addYear(a, P * 100);
    },
    onChange: l,
    getStart: d,
    getEnd: m
  }, y), /* @__PURE__ */ o.createElement(Tt, Se({}, e, {
    disabledDate: k,
    colNum: 3,
    rowNum: 4,
    baseDate: S,
    getCellDate: v,
    getCellText: h,
    getCellClassName: M
  }))));
}
function Ao(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, a = e.pickerValue, i = e.disabledDate, l = e.onPickerValueChange, u = e.onModeChange, s = "".concat(t, "-month-panel"), f = kt(e, "month"), c = B(f, 1), d = c[0], m = r.setMonth(a, 0), p = n.shortMonths || (r.locale.getShortMonths ? r.locale.getShortMonths(n.locale) : []), C = function(y, I) {
    return r.addMonth(y, I);
  }, S = function(y) {
    var I = r.getMonth(y);
    return n.monthFormat ? _e(y, {
      locale: n,
      format: n.monthFormat,
      generateConfig: r
    }) : p[I];
  }, v = function() {
    return pe({}, "".concat(t, "-cell-in-view"), !0);
  }, h = i ? function(k, y) {
    var I = r.setDate(k, 1), P = r.setMonth(I, r.getMonth(I) + 1), E = r.addDate(P, -1);
    return i(I, y) && i(E, y);
  } : null, M = /* @__PURE__ */ o.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": n.yearSelect,
    onClick: function() {
      u("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, _e(a, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: d
  }, /* @__PURE__ */ o.createElement("div", {
    className: s
  }, /* @__PURE__ */ o.createElement(wt, {
    superOffset: function(y) {
      return r.addYear(a, y);
    },
    onChange: l,
    getStart: function(y) {
      return r.setMonth(y, 0);
    },
    getEnd: function(y) {
      return r.setMonth(y, 11);
    }
  }, M), /* @__PURE__ */ o.createElement(Tt, Se({}, e, {
    disabledDate: h,
    titleFormat: n.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: m,
    getCellDate: C,
    getCellText: S,
    getCellClassName: v
  }))));
}
function Lo(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, a = e.pickerValue, i = e.onPickerValueChange, l = e.onModeChange, u = "".concat(t, "-quarter-panel"), s = kt(e, "quarter"), f = B(s, 1), c = f[0], d = r.setMonth(a, 0), m = function(h, M) {
    return r.addMonth(h, M * 3);
  }, p = function(h) {
    return _e(h, {
      locale: n,
      format: n.cellQuarterFormat,
      generateConfig: r
    });
  }, C = function() {
    return pe({}, "".concat(t, "-cell-in-view"), !0);
  }, S = /* @__PURE__ */ o.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": n.yearSelect,
    onClick: function() {
      l("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, _e(a, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: c
  }, /* @__PURE__ */ o.createElement("div", {
    className: u
  }, /* @__PURE__ */ o.createElement(wt, {
    superOffset: function(h) {
      return r.addYear(a, h);
    },
    onChange: i,
    getStart: function(h) {
      return r.setMonth(h, 0);
    },
    getEnd: function(h) {
      return r.setMonth(h, 11);
    }
  }, S), /* @__PURE__ */ o.createElement(Tt, Se({}, e, {
    titleFormat: n.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: d,
    getCellDate: m,
    getCellText: p,
    getCellClassName: C
  }))));
}
function Bo(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, a = e.value, i = e.hoverValue, l = e.hoverRangeValue, u = r.locale, s = "".concat(t, "-week-panel-row"), f = function(d) {
    var m = {};
    if (l) {
      var p = B(l, 2), C = p[0], S = p[1], v = Ot(n, u, C, d), h = Ot(n, u, S, d);
      m["".concat(s, "-range-start")] = v, m["".concat(s, "-range-end")] = h, m["".concat(s, "-range-hover")] = !v && !h && an(n, C, S, d);
    }
    return i && (m["".concat(s, "-hover")] = i.some(function(M) {
      return Ot(n, u, d, M);
    })), $e(
      s,
      pe({}, "".concat(s, "-selected"), !l && Ot(n, u, a, d)),
      // Patch for hover range
      m
    );
  };
  return /* @__PURE__ */ o.createElement(ln, Se({}, e, {
    mode: "week",
    panelName: "week",
    rowClassName: f
  }));
}
function Wo(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, a = e.pickerValue, i = e.disabledDate, l = e.onPickerValueChange, u = e.onModeChange, s = "".concat(t, "-year-panel"), f = kt(e, "year"), c = B(f, 1), d = c[0], m = function(E) {
    var L = Math.floor(r.getYear(E) / 10) * 10;
    return r.setYear(E, L);
  }, p = function(E) {
    var L = m(E);
    return r.addYear(L, 9);
  }, C = m(a), S = p(a), v = r.addYear(C, -1), h = function(E, L) {
    return r.addYear(E, L);
  }, M = function(E) {
    return _e(E, {
      locale: n,
      format: n.cellYearFormat,
      generateConfig: r
    });
  }, k = function(E) {
    return pe({}, "".concat(t, "-cell-in-view"), vt(r, E, C) || vt(r, E, S) || an(r, C, S, E));
  }, y = i ? function(P, E) {
    var L = r.setMonth(P, 0), Y = r.setDate(L, 1), O = r.addYear(Y, 1), V = r.addDate(O, -1);
    return i(Y, E) && i(V, E);
  } : null, I = /* @__PURE__ */ o.createElement("button", {
    type: "button",
    key: "decade",
    "aria-label": n.decadeSelect,
    onClick: function() {
      u("decade");
    },
    tabIndex: -1,
    className: "".concat(t, "-decade-btn")
  }, _e(C, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }), "-", _e(S, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ o.createElement(pt.Provider, {
    value: d
  }, /* @__PURE__ */ o.createElement("div", {
    className: s
  }, /* @__PURE__ */ o.createElement(wt, {
    superOffset: function(E) {
      return r.addYear(a, E * 10);
    },
    onChange: l,
    getStart: m,
    getEnd: p
  }, I), /* @__PURE__ */ o.createElement(Tt, Se({}, e, {
    disabledDate: y,
    titleFormat: n.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: v,
    getCellDate: h,
    getCellText: M,
    getCellClassName: k
  }))));
}
var jo = {
  date: ln,
  datetime: Fo,
  week: Bo,
  month: Ao,
  quarter: Lo,
  year: Wo,
  decade: Yo,
  time: ra
};
function zo(e, t) {
  var n, r = e.locale, a = e.generateConfig, i = e.direction, l = e.prefixCls, u = e.tabIndex, s = u === void 0 ? 0 : u, f = e.multiple, c = e.defaultValue, d = e.value, m = e.onChange, p = e.onSelect, C = e.defaultPickerValue, S = e.pickerValue, v = e.onPickerValueChange, h = e.mode, M = e.onPanelChange, k = e.picker, y = k === void 0 ? "date" : k, I = e.showTime, P = e.hoverValue, E = e.hoverRangeValue, L = e.cellRender, Y = e.dateRender, O = e.monthCellRender, V = e.components, A = V === void 0 ? {} : V, T = e.hideHeader, x = ((n = o.useContext(Xe)) === null || n === void 0 ? void 0 : n.prefixCls) || l || "rc-picker", g = o.useRef();
  o.useImperativeHandle(t, function() {
    return {
      nativeElement: g.current
    };
  });
  var b = Ar(e), $ = B(b, 4), w = $[0], H = $[1], R = $[2], N = $[3], D = Tr(r, H), _ = y === "date" && I ? "datetime" : y, F = o.useMemo(function() {
    return Lr(_, R, N, w, D);
  }, [_, R, N, w, D]), q = a.getNow(), X = rt(y, {
    value: h,
    postState: function(ee) {
      return ee || "date";
    }
  }), z = B(X, 2), Q = z[0], K = z[1], W = Q === "date" && F ? "datetime" : Q, U = na(a, r, _), re = rt(c, {
    value: d
  }), te = B(re, 2), le = te[0], ge = te[1], J = o.useMemo(function() {
    var G = ht(le).filter(function(ee) {
      return ee;
    });
    return f ? G : G.slice(0, 1);
  }, [le, f]), Ce = Ye(function(G) {
    ge(G), m && (G === null || J.length !== G.length || J.some(function(ee, ae) {
      return !Le(a, r, ee, G[ae], _);
    })) && (m == null || m(f ? G : G[0]));
  }), ue = Ye(function(G) {
    if (p == null || p(G), Q === y) {
      var ee = f ? U(J, G) : [G];
      Ce(ee);
    }
  }), xe = rt(C || J[0] || q, {
    value: S
  }), fe = B(xe, 2), be = fe[0], ye = fe[1];
  o.useEffect(function() {
    J[0] && !S && ye(J[0]);
  }, [J[0]]);
  var Ie = function(ee, ae) {
    M == null || M(ee || S, ae || Q);
  }, Ee = function(ee) {
    var ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    ye(ee), v == null || v(ee), ae && Ie(ee);
  }, De = function(ee, ae) {
    K(ee), ae && Ee(ae), Ie(ae, ee);
  }, ve = function(ee) {
    if (ue(ee), Ee(ee), Q !== y) {
      var ae = ["decade", "year"], j = [].concat(ae, ["month"]), Z = {
        quarter: [].concat(ae, ["quarter"]),
        week: [].concat(Be(j), ["week"]),
        date: [].concat(Be(j), ["date"])
      }, we = Z[y] || j, Me = we.indexOf(Q), Oe = we[Me + 1];
      Oe && De(Oe, ee);
    }
  }, Ve = o.useMemo(function() {
    var G, ee;
    if (Array.isArray(E)) {
      var ae = B(E, 2);
      G = ae[0], ee = ae[1];
    } else
      G = E;
    return !G && !ee ? null : (G = G || ee, ee = ee || G, a.isAfter(G, ee) ? [ee, G] : [G, ee]);
  }, [E, a]), Ne = jn(L, Y, O), Re = A[W] || jo[W] || ln, Te = o.useContext(at), He = o.useMemo(function() {
    return ie(ie({}, Te), {}, {
      hideHeader: T
    });
  }, [Te, T]);
  process.env.NODE_ENV !== "production" && Ge(!J || J.every(function(G) {
    return a.isValidate(G);
  }), "Invalidate date pass to `value` or `defaultValue`.");
  var ce = "".concat(x, "-panel"), ke = rn(e, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ o.createElement(at.Provider, {
    value: He
  }, /* @__PURE__ */ o.createElement("div", {
    ref: g,
    tabIndex: s,
    className: $e(ce, pe({}, "".concat(ce, "-rtl"), i === "rtl"))
  }, /* @__PURE__ */ o.createElement(Re, Se({}, ke, {
    // Time
    showTime: F,
    prefixCls: x,
    locale: D,
    generateConfig: a,
    onModeChange: De,
    pickerValue: be,
    onPickerValueChange: function(ee) {
      Ee(ee, !0);
    },
    value: J[0],
    onSelect: ve,
    values: J,
    cellRender: Ne,
    hoverRangeValue: Ve,
    hoverValue: P
  }))));
}
var Zt = /* @__PURE__ */ o.memo(/* @__PURE__ */ o.forwardRef(zo));
process.env.NODE_ENV !== "production" && (Zt.displayName = "PanelPicker");
function Uo(e) {
  var t = e.picker, n = e.multiplePanel, r = e.pickerValue, a = e.onPickerValueChange, i = e.needConfirm, l = e.onSubmit, u = e.range, s = e.hoverValue, f = o.useContext(Xe), c = f.prefixCls, d = f.generateConfig, m = o.useCallback(function(M, k) {
    return _t(d, t, M, k);
  }, [d, t]), p = o.useMemo(function() {
    return m(r, 1);
  }, [r, m]), C = function(k) {
    a(m(k, -1));
  }, S = {
    onCellDblClick: function() {
      i && l();
    }
  }, v = t === "time", h = ie(ie({}, e), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: v
  });
  return u ? h.hoverRangeValue = s : h.hoverValue = s, n ? /* @__PURE__ */ o.createElement("div", {
    className: "".concat(c, "-panels")
  }, /* @__PURE__ */ o.createElement(at.Provider, {
    value: ie(ie({}, S), {}, {
      hideNext: !0
    })
  }, /* @__PURE__ */ o.createElement(Zt, h)), /* @__PURE__ */ o.createElement(at.Provider, {
    value: ie(ie({}, S), {}, {
      hidePrev: !0
    })
  }, /* @__PURE__ */ o.createElement(Zt, Se({}, h, {
    pickerValue: p,
    onPickerValueChange: C
  })))) : /* @__PURE__ */ o.createElement(at.Provider, {
    value: ie({}, S)
  }, /* @__PURE__ */ o.createElement(Zt, h));
}
function tr(e) {
  return typeof e == "function" ? e() : e;
}
function qo(e) {
  var t = e.prefixCls, n = e.presets, r = e.onClick, a = e.onHover;
  return n.length ? /* @__PURE__ */ o.createElement("div", {
    className: "".concat(t, "-presets")
  }, /* @__PURE__ */ o.createElement("ul", null, n.map(function(i, l) {
    var u = i.label, s = i.value;
    return /* @__PURE__ */ o.createElement("li", {
      key: l,
      onClick: function() {
        r(tr(s));
      },
      onMouseEnter: function() {
        a(tr(s));
      },
      onMouseLeave: function() {
        a(null);
      }
    }, u);
  }))) : null;
}
function aa(e) {
  var t = e.panelRender, n = e.internalMode, r = e.picker, a = e.showNow, i = e.range, l = e.multiple, u = e.activeInfo, s = u === void 0 ? [0, 0, 0] : u, f = e.presets, c = e.onPresetHover, d = e.onPresetSubmit, m = e.onFocus, p = e.onBlur, C = e.onPanelMouseDown, S = e.direction, v = e.value, h = e.onSelect, M = e.isInvalid, k = e.defaultOpenValue, y = e.onOk, I = e.onSubmit, P = o.useContext(Xe), E = P.prefixCls, L = "".concat(E, "-panel"), Y = S === "rtl", O = o.useRef(null), V = o.useRef(null), A = o.useState(0), T = B(A, 2), x = T[0], g = T[1], b = o.useState(0), $ = B(b, 2), w = $[0], H = $[1], R = o.useState(0), N = B(R, 2), D = N[0], _ = N[1], F = function(ve) {
    ve.width && g(ve.width);
  }, q = B(s, 3), X = q[0], z = q[1], Q = q[2], K = o.useState(0), W = B(K, 2), U = W[0], re = W[1];
  o.useEffect(function() {
    re(10);
  }, [X]), o.useEffect(function() {
    if (i && V.current) {
      var De, ve = ((De = O.current) === null || De === void 0 ? void 0 : De.offsetWidth) || 0, Ve = V.current.getBoundingClientRect();
      if (!Ve.height || Ve.right < 0) {
        re(function(He) {
          return Math.max(0, He - 1);
        });
        return;
      }
      var Ne = (Y ? z - ve : X) - Ve.left;
      if (_(Ne), x && x < Q) {
        var Re = Y ? Ve.right - (z - ve + x) : X + ve - Ve.left - x, Te = Math.max(0, Re);
        H(Te);
      } else
        H(0);
    }
  }, [U, Y, x, X, z, Q, i]);
  function te(De) {
    return De.filter(function(ve) {
      return ve;
    });
  }
  var le = o.useMemo(function() {
    return te(ht(v));
  }, [v]), ge = r === "time" && !le.length, J = o.useMemo(function() {
    return ge ? te([k]) : le;
  }, [ge, le, k]), Ce = ge ? k : le, ue = o.useMemo(function() {
    return J.length ? J.some(function(De) {
      return M(De);
    }) : !0;
  }, [J, M]), xe = function() {
    ge && h(k), y(), I();
  }, fe = /* @__PURE__ */ o.createElement("div", {
    className: "".concat(E, "-panel-layout")
  }, /* @__PURE__ */ o.createElement(qo, {
    prefixCls: E,
    presets: f,
    onClick: d,
    onHover: c
  }), /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement(Uo, Se({}, e, {
    value: Ce
  })), /* @__PURE__ */ o.createElement(Ro, Se({}, e, {
    showNow: l ? !1 : a,
    invalid: ue,
    onSubmit: xe
  }))));
  t && (fe = t(fe));
  var be = "".concat(L, "-container"), ye = "marginLeft", Ie = "marginRight", Ee = /* @__PURE__ */ o.createElement("div", {
    onMouseDown: C,
    tabIndex: -1,
    className: $e(
      be,
      // Used for Today Button style, safe to remove if no need
      "".concat(E, "-").concat(n, "-panel-container")
    ),
    style: pe(pe({}, Y ? Ie : ye, w), Y ? ye : Ie, "auto"),
    onFocus: m,
    onBlur: p
  }, fe);
  return i && (Ee = /* @__PURE__ */ o.createElement("div", {
    onMouseDown: C,
    ref: V,
    className: $e("".concat(E, "-range-wrapper"), "".concat(E, "-").concat(r, "-range-wrapper"))
  }, /* @__PURE__ */ o.createElement("div", {
    ref: O,
    className: "".concat(E, "-range-arrow"),
    style: {
      left: D
    }
  }), /* @__PURE__ */ o.createElement(dr, {
    onResize: F
  }, Ee))), Ee;
}
function oa(e, t) {
  var n = e.format, r = e.maskFormat, a = e.generateConfig, i = e.locale, l = e.preserveInvalidOnBlur, u = e.inputReadOnly, s = e.required, f = e["aria-required"], c = e.onSubmit, d = e.onFocus, m = e.onBlur, p = e.onInputChange, C = e.onInvalid, S = e.open, v = e.onOpenChange, h = e.onKeyDown, M = e.onChange, k = e.activeHelp, y = e.name, I = e.autoComplete, P = e.id, E = e.value, L = e.invalid, Y = e.placeholder, O = e.disabled, V = e.activeIndex, A = e.allHelp, T = e.picker, x = function(D, _) {
    var F = a.locale.parse(i.locale, D, [_]);
    return F && a.isValidate(F) ? F : null;
  }, g = n[0], b = o.useCallback(function(N) {
    return _e(N, {
      locale: i,
      format: g,
      generateConfig: a
    });
  }, [i, a, g]), $ = o.useMemo(function() {
    return E.map(b);
  }, [E, b]), w = o.useMemo(function() {
    var N = T === "time" ? 8 : 10, D = typeof g == "function" ? g(a.getNow()).length : g.length;
    return Math.max(N, D) + 2;
  }, [g, T, a]), H = function(D) {
    for (var _ = 0; _ < n.length; _ += 1) {
      var F = n[_];
      if (typeof F == "string") {
        var q = x(D, F);
        if (q)
          return q;
      }
    }
    return !1;
  }, R = function(D) {
    function _(X) {
      return D !== void 0 ? X[D] : X;
    }
    var F = Bn(e, {
      aria: !0,
      data: !0
    }), q = ie(ie({}, F), {}, {
      // ============== Shared ==============
      format: r,
      validateFormat: function(z) {
        return !!H(z);
      },
      preserveInvalidOnBlur: l,
      readOnly: u,
      required: s,
      "aria-required": f,
      name: y,
      autoComplete: I,
      size: w,
      // ============= By Index =============
      id: _(P),
      value: _($) || "",
      invalid: _(L),
      placeholder: _(Y),
      active: V === D,
      helped: A || k && V === D,
      disabled: _(O),
      onFocus: function(z) {
        d(z, D);
      },
      onBlur: function(z) {
        m(z, D);
      },
      onSubmit: c,
      // Get validate text value
      onChange: function(z) {
        p();
        var Q = H(z);
        if (Q) {
          C(!1, D), M(Q, D);
          return;
        }
        C(!!z, D);
      },
      onHelp: function() {
        v(!0, {
          index: D
        });
      },
      onKeyDown: function(z) {
        var Q = !1;
        if (h == null || h(z, function() {
          process.env.NODE_ENV !== "production" && Ge(!1, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly."), Q = !0;
        }), !z.defaultPrevented && !Q)
          switch (z.key) {
            case "Escape":
              v(!1, {
                index: D
              });
              break;
            case "Enter":
              S || v(!0);
              break;
          }
      }
    }, t == null ? void 0 : t({
      valueTexts: $
    }));
    return Object.keys(q).forEach(function(X) {
      q[X] === void 0 && delete q[X];
    }), q;
  };
  return [R, b];
}
var Ko = ["onMouseEnter", "onMouseLeave"];
function ia(e) {
  return o.useMemo(function() {
    return rn(e, Ko);
  }, [e]);
}
var Go = ["icon", "type"], Xo = ["onClear"];
function un(e) {
  var t = e.icon, n = e.type, r = xt(e, Go), a = o.useContext(Xe), i = a.prefixCls;
  return t ? /* @__PURE__ */ o.createElement("span", Se({
    className: "".concat(i, "-").concat(n)
  }, r), t) : null;
}
function Fn(e) {
  var t = e.onClear, n = xt(e, Xo);
  return /* @__PURE__ */ o.createElement(un, Se({}, n, {
    type: "clear",
    role: "button",
    onMouseDown: function(a) {
      a.preventDefault();
    },
    onClick: function(a) {
      a.stopPropagation(), t();
    }
  }));
}
var On = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"], nr = "顧", Qo = /* @__PURE__ */ function() {
  function e(t) {
    Da(this, e), pe(this, "format", void 0), pe(this, "maskFormat", void 0), pe(this, "cells", void 0), pe(this, "maskCells", void 0), this.format = t;
    var n = On.map(function(u) {
      return "(".concat(u, ")");
    }).join("|"), r = new RegExp(n, "g");
    this.maskFormat = t.replace(
      r,
      // Use Chinese character to avoid user use it in format
      function(u) {
        return nr.repeat(u.length);
      }
    );
    var a = new RegExp("(".concat(On.join("|"), ")")), i = (t.split(a) || []).filter(function(u) {
      return u;
    }), l = 0;
    this.cells = i.map(function(u) {
      var s = On.includes(u), f = l, c = l + u.length;
      return l = c, {
        text: u,
        mask: s,
        start: f,
        end: c
      };
    }), this.maskCells = this.cells.filter(function(u) {
      return u.mask;
    });
  }
  return $a(e, [{
    key: "getSelection",
    value: function(n) {
      var r = this.maskCells[n] || {}, a = r.start, i = r.end;
      return [a || 0, i || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function(n) {
      for (var r = 0; r < this.maskFormat.length; r += 1) {
        var a = this.maskFormat[r], i = n[r];
        if (!i || a !== nr && a !== i)
          return !1;
      }
      return !0;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function(n) {
      for (var r = Number.MAX_SAFE_INTEGER, a = 0, i = 0; i < this.maskCells.length; i += 1) {
        var l = this.maskCells[i], u = l.start, s = l.end;
        if (n >= u && n <= s)
          return i;
        var f = Math.min(Math.abs(n - u), Math.abs(n - s));
        f < r && (r = f, a = i);
      }
      return a;
    }
  }]), e;
}();
function Zo(e) {
  var t = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return t[e];
}
var Jo = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"], nn = /* @__PURE__ */ o.forwardRef(function(e, t) {
  var n = e.active, r = e.showActiveCls, a = r === void 0 ? !0 : r, i = e.suffixIcon, l = e.format, u = e.validateFormat, s = e.onChange;
  e.onInput;
  var f = e.helped, c = e.onHelp, d = e.onSubmit, m = e.onKeyDown, p = e.preserveInvalidOnBlur, C = p === void 0 ? !1 : p, S = e.invalid, v = e.clearIcon, h = xt(e, Jo), M = e.value, k = e.onFocus, y = e.onBlur, I = e.onMouseUp, P = o.useContext(Xe), E = P.prefixCls, L = P.input, Y = L === void 0 ? "input" : L, O = "".concat(E, "-input"), V = o.useState(!1), A = B(V, 2), T = A[0], x = A[1], g = o.useState(M), b = B(g, 2), $ = b[0], w = b[1], H = o.useState(""), R = B(H, 2), N = R[0], D = R[1], _ = o.useState(null), F = B(_, 2), q = F[0], X = F[1], z = o.useState(null), Q = B(z, 2), K = Q[0], W = Q[1], U = $ || "";
  o.useEffect(function() {
    w(M);
  }, [M]);
  var re = o.useRef(), te = o.useRef();
  o.useImperativeHandle(t, function() {
    return {
      nativeElement: re.current,
      inputElement: te.current,
      focus: function(G) {
        te.current.focus(G);
      },
      blur: function() {
        te.current.blur();
      }
    };
  });
  var le = o.useMemo(function() {
    return new Qo(l || "");
  }, [l]), ge = o.useMemo(function() {
    return f ? [0, 0] : le.getSelection(q);
  }, [le, q, f]), J = B(ge, 2), Ce = J[0], ue = J[1], xe = function(G) {
    G && G !== l && G !== M && c();
  }, fe = Ye(function(ke) {
    u(ke) && s(ke), w(ke), xe(ke);
  }), be = function(G) {
    if (!l) {
      var ee = G.target.value;
      xe(ee), w(ee), s(ee);
    }
  }, ye = function(G) {
    var ee = G.clipboardData.getData("text");
    u(ee) && fe(ee);
  }, Ie = o.useRef(!1), Ee = function() {
    Ie.current = !0;
  }, De = function(G) {
    var ee = G.target, ae = ee.selectionStart, j = le.getMaskCellIndex(ae);
    X(j), W({}), I == null || I(G), Ie.current = !1;
  }, ve = function(G) {
    x(!0), X(0), D(""), k(G);
  }, Ve = function(G) {
    y(G);
  }, Ne = function(G) {
    x(!1), Ve(G);
  };
  qn(n, function() {
    !n && !C && w(M);
  });
  var Re = function(G) {
    G.key === "Enter" && u(U) && d(), m == null || m(G);
  }, Te = function(G) {
    Re(G);
    var ee = G.key, ae = null, j = null, Z = ue - Ce, we = l.slice(Ce, ue), Me = function(Ke) {
      X(function(Ue) {
        var Ae = Ue + Ke;
        return Ae = Math.max(Ae, 0), Ae = Math.min(Ae, le.size() - 1), Ae;
      });
    }, Oe = function(Ke) {
      var Ue = Zo(we), Ae = B(Ue, 3), Je = Ae[0], Ct = Ae[1], bt = Ae[2], ot = U.slice(Ce, ue), ct = Number(ot);
      if (isNaN(ct))
        return String(bt || (Ke > 0 ? Je : Ct));
      var st = ct + Ke, dt = Ct - Je + 1;
      return String(Je + (dt + st - Je) % dt);
    };
    switch (ee) {
      case "Backspace":
      case "Delete":
        ae = "", j = we;
        break;
      case "ArrowLeft":
        ae = "", Me(-1);
        break;
      case "ArrowRight":
        ae = "", Me(1);
        break;
      case "ArrowUp":
        ae = "", j = Oe(1);
        break;
      case "ArrowDown":
        ae = "", j = Oe(-1);
        break;
      default:
        isNaN(Number(ee)) || (ae = N + ee, j = ae);
        break;
    }
    if (ae !== null && (D(ae), ae.length >= Z && (Me(1), D(""))), j !== null) {
      var qe = (
        // before
        U.slice(0, Ce) + // replace
        Wn(j, Z) + // after
        U.slice(ue)
      );
      fe(qe.slice(0, l.length));
    }
    W({});
  }, He = o.useRef();
  lt(function() {
    if (!(!T || !l || Ie.current)) {
      if (!le.match(U)) {
        fe(l);
        return;
      }
      return te.current.setSelectionRange(Ce, ue), He.current = nt(function() {
        te.current.setSelectionRange(Ce, ue);
      }), function() {
        nt.cancel(He.current);
      };
    }
  }, [le, l, T, U, q, Ce, ue, K, fe]);
  var ce = l ? {
    onFocus: ve,
    onBlur: Ne,
    onKeyDown: Te,
    onMouseDown: Ee,
    onMouseUp: De,
    onPaste: ye
  } : {};
  return /* @__PURE__ */ o.createElement("div", {
    ref: re,
    className: $e(O, pe(pe({}, "".concat(O, "-active"), n && a), "".concat(O, "-placeholder"), f))
  }, /* @__PURE__ */ o.createElement(Y, Se({
    ref: te,
    "aria-invalid": S,
    autoComplete: "off"
  }, h, {
    onKeyDown: Re,
    onBlur: Ve
    // Replace with format
  }, ce, {
    // Value
    value: U,
    onChange: be
  })), /* @__PURE__ */ o.createElement(un, {
    type: "suffix",
    icon: i
  }), v);
});
process.env.NODE_ENV !== "production" && (nn.displayName = "Input");
var ei = ["id", "prefix", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveInfo", "placement", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex"], ti = ["index"];
function ni(e, t) {
  var n = e.id, r = e.prefix, a = e.clearIcon, i = e.suffixIcon, l = e.separator, u = l === void 0 ? "~" : l, s = e.activeIndex;
  e.activeHelp, e.allHelp;
  var f = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown, e.locale, e.generateConfig;
  var c = e.placeholder, d = e.className, m = e.style, p = e.onClick, C = e.onClear, S = e.value;
  e.onChange, e.onSubmit, e.onInputChange, e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var v = e.disabled, h = e.invalid;
  e.inputReadOnly;
  var M = e.direction;
  e.onOpenChange;
  var k = e.onActiveInfo;
  e.placement;
  var y = e.onMouseDown;
  e.required, e["aria-required"];
  var I = e.autoFocus, P = e.tabIndex, E = xt(e, ei), L = M === "rtl", Y = o.useContext(Xe), O = Y.prefixCls, V = o.useMemo(function() {
    if (typeof n == "string")
      return [n];
    var K = n || {};
    return [K.start, K.end];
  }, [n]), A = o.useRef(), T = o.useRef(), x = o.useRef(), g = function(W) {
    var U;
    return (U = [T, x][W]) === null || U === void 0 ? void 0 : U.current;
  };
  o.useImperativeHandle(t, function() {
    return {
      nativeElement: A.current,
      focus: function(W) {
        if (Ht(W) === "object") {
          var U, re = W || {}, te = re.index, le = te === void 0 ? 0 : te, ge = xt(re, ti);
          (U = g(le)) === null || U === void 0 || U.focus(ge);
        } else {
          var J;
          (J = g(W ?? 0)) === null || J === void 0 || J.focus();
        }
      },
      blur: function() {
        var W, U;
        (W = g(0)) === null || W === void 0 || W.blur(), (U = g(1)) === null || U === void 0 || U.blur();
      }
    };
  });
  var b = ia(E), $ = o.useMemo(function() {
    return Array.isArray(c) ? c : [c, c];
  }, [c]), w = oa(ie(ie({}, e), {}, {
    id: V,
    placeholder: $
  })), H = B(w, 1), R = H[0], N = o.useState({
    position: "absolute",
    width: 0
  }), D = B(N, 2), _ = D[0], F = D[1], q = Ye(function() {
    var K = g(s);
    if (K) {
      var W = K.nativeElement.getBoundingClientRect(), U = A.current.getBoundingClientRect(), re = W.left - U.left;
      F(function(te) {
        return ie(ie({}, te), {}, {
          width: W.width,
          left: re
        });
      }), k([W.left, W.right, U.width]);
    }
  });
  o.useEffect(function() {
    q();
  }, [s]);
  var X = a && (S[0] && !v[0] || S[1] && !v[1]), z = I && !v[0], Q = I && !z && !v[1];
  return /* @__PURE__ */ o.createElement(dr, {
    onResize: q
  }, /* @__PURE__ */ o.createElement("div", Se({}, b, {
    className: $e(O, "".concat(O, "-range"), pe(pe(pe(pe({}, "".concat(O, "-focused"), f), "".concat(O, "-disabled"), v.every(function(K) {
      return K;
    })), "".concat(O, "-invalid"), h.some(function(K) {
      return K;
    })), "".concat(O, "-rtl"), L), d),
    style: m,
    ref: A,
    onClick: p,
    onMouseDown: function(W) {
      var U = W.target;
      U !== T.current.inputElement && U !== x.current.inputElement && W.preventDefault(), y == null || y(W);
    }
  }), r && /* @__PURE__ */ o.createElement("div", {
    className: "".concat(O, "-prefix")
  }, r), /* @__PURE__ */ o.createElement(nn, Se({
    ref: T
  }, R(0), {
    autoFocus: z,
    tabIndex: P,
    "date-range": "start"
  })), /* @__PURE__ */ o.createElement("div", {
    className: "".concat(O, "-range-separator")
  }, u), /* @__PURE__ */ o.createElement(nn, Se({
    ref: x
  }, R(1), {
    autoFocus: Q,
    tabIndex: P,
    "date-range": "end"
  })), /* @__PURE__ */ o.createElement("div", {
    className: "".concat(O, "-active-bar"),
    style: _
  }), /* @__PURE__ */ o.createElement(un, {
    type: "suffix",
    icon: i
  }), X && /* @__PURE__ */ o.createElement(Fn, {
    icon: a,
    onClear: C
  })));
}
var la = /* @__PURE__ */ o.forwardRef(ni);
process.env.NODE_ENV !== "production" && (la.displayName = "RangeSelector");
function rr(e, t) {
  var n = e ?? t;
  return Array.isArray(n) ? n : [n, n];
}
function Xt(e) {
  return e === 1 ? "end" : "start";
}
function ri(e, t) {
  var n = jr(e, function() {
    var me = e.disabled, ne = e.allowEmpty, de = rr(me, !1), Pe = rr(ne, !1);
    return {
      disabled: de,
      allowEmpty: Pe
    };
  }), r = B(n, 6), a = r[0], i = r[1], l = r[2], u = r[3], s = r[4], f = r[5], c = a.prefixCls, d = a.styles, m = a.classNames, p = a.defaultValue, C = a.value, S = a.needConfirm, v = a.onKeyDown, h = a.disabled, M = a.allowEmpty, k = a.disabledDate, y = a.minDate, I = a.maxDate, P = a.defaultOpen, E = a.open, L = a.onOpenChange, Y = a.locale, O = a.generateConfig, V = a.picker, A = a.showNow, T = a.showToday, x = a.showTime, g = a.mode, b = a.onPanelChange, $ = a.onCalendarChange, w = a.onOk, H = a.defaultPickerValue, R = a.pickerValue, N = a.onPickerValueChange, D = a.inputReadOnly, _ = a.suffixIcon, F = a.onFocus, q = a.onBlur, X = a.presets, z = a.ranges, Q = a.components, K = a.cellRender, W = a.dateRender, U = a.monthCellRender, re = a.onClick, te = Ur(t), le = zr(E, P, h, L), ge = B(le, 2), J = ge[0], Ce = ge[1], ue = function(ne, de) {
    (h.some(function(Pe) {
      return !Pe;
    }) || !ne) && Ce(ne, de);
  }, xe = Jr(O, Y, u, !0, !1, p, C, $, w), fe = B(xe, 5), be = fe[0], ye = fe[1], Ie = fe[2], Ee = fe[3], De = fe[4], ve = Ie(), Ve = Kr(h, M, J), Ne = B(Ve, 9), Re = Ne[0], Te = Ne[1], He = Ne[2], ce = Ne[3], ke = Ne[4], G = Ne[5], ee = Ne[6], ae = Ne[7], j = Ne[8], Z = function(ne, de) {
    Te(!0), F == null || F(ne, {
      range: Xt(de ?? ce)
    });
  }, we = function(ne, de) {
    Te(!1), q == null || q(ne, {
      range: Xt(de ?? ce)
    });
  }, Me = o.useMemo(function() {
    if (!x)
      return null;
    var me = x.disabledTime, ne = me ? function(de) {
      var Pe = Xt(ce), Fe = Or(ve, ee, ce);
      return me(de, Pe, {
        from: Fe
      });
    } : void 0;
    return ie(ie({}, x), {}, {
      disabledTime: ne
    });
  }, [x, ce, ve, ee]), Oe = rt([V, V], {
    value: g
  }), qe = B(Oe, 2), We = qe[0], Ke = qe[1], Ue = We[ce] || V, Ae = Ue === "date" && Me ? "datetime" : Ue, Je = Ae === V && Ae !== "time", Ct = ta(V, Ue, A, T, !0), bt = ea(a, be, ye, Ie, Ee, h, u, Re, J, f), ot = B(bt, 2), ct = ot[0], st = ot[1], dt = Po(ve, h, ee, O, Y, k), cn = Vr(ve, f, M), Ft = B(cn, 2), sn = Ft[0], dn = Ft[1], Yt = Gr(O, Y, ve, We, J, ce, i, Je, H, R, Me == null ? void 0 : Me.defaultOpenValue, N, y, I), At = B(Yt, 2), fn = At[0], Lt = At[1], et = Ye(function(me, ne, de) {
    var Pe = Vt(We, ce, ne);
    if ((Pe[0] !== We[0] || Pe[1] !== We[1]) && Ke(Pe), b && de !== !1) {
      var Fe = Be(ve);
      me && (Fe[ce] = me), b(Fe, Pe);
    }
  }), $t = function(ne, de) {
    return (
      // Trigger change only when date changed
      Vt(ve, de, ne)
    );
  }, Qe = function(ne, de) {
    var Pe = ve;
    ne && (Pe = $t(ne, ce)), ae(ce);
    var Fe = G(Pe);
    Ee(Pe), ct(ce, Fe === null), Fe === null ? ue(!1, {
      force: !0
    }) : de || te.current.focus({
      index: Fe
    });
  }, vn = function(ne) {
    var de, Pe = ne.target.getRootNode();
    if (!te.current.nativeElement.contains((de = Pe.activeElement) !== null && de !== void 0 ? de : document.activeElement)) {
      var Fe = h.findIndex(function(xa) {
        return !xa;
      });
      Fe >= 0 && te.current.focus({
        index: Fe
      });
    }
    ue(!0), re == null || re(ne);
  }, Bt = function() {
    st(null), ue(!1, {
      force: !0
    });
  }, mn = o.useState(null), Dt = B(mn, 2), gn = Dt[0], Pt = Dt[1], tt = o.useState(null), St = B(tt, 2), yt = St[0], It = St[1], Wt = o.useMemo(function() {
    return yt || ve;
  }, [ve, yt]);
  o.useEffect(function() {
    J || It(null);
  }, [J]);
  var hn = o.useState([0, 0, 0]), Et = B(hn, 2), pn = Et[0], Cn = Et[1], bn = qr(X, z), Sn = function(ne) {
    It(ne), Pt("preset");
  }, yn = function(ne) {
    var de = st(ne);
    de && ue(!1, {
      force: !0
    });
  }, xn = function(ne) {
    Qe(ne);
  }, kn = function(ne) {
    It(ne ? $t(ne, ce) : null), Pt("cell");
  }, wn = function(ne) {
    ue(!0), Z(ne);
  }, Mn = function() {
    He("panel");
  }, $n = function(ne) {
    var de = Vt(ve, ce, ne);
    Ee(de), !S && !l && i === Ae && Qe(ne);
  }, Dn = function() {
    ue(!1);
  }, Pn = jn(K, W, U, Xt(ce)), In = ve[ce] || null, En = Ye(function(me) {
    return f(me, {
      activeIndex: ce
    });
  }), se = o.useMemo(function() {
    var me = Bn(a, !1), ne = sr(a, [].concat(Be(Object.keys(me)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange", "disabledTime"]));
    return ne;
  }, [a]), oe = /* @__PURE__ */ o.createElement(aa, Se({}, se, {
    showNow: Ct,
    showTime: Me,
    range: !0,
    multiplePanel: Je,
    activeInfo: pn,
    disabledDate: dt,
    onFocus: wn,
    onBlur: we,
    onPanelMouseDown: Mn,
    picker: V,
    mode: Ue,
    internalMode: Ae,
    onPanelChange: et,
    format: s,
    value: In,
    isInvalid: En,
    onChange: null,
    onSelect: $n,
    pickerValue: fn,
    defaultOpenValue: ht(x == null ? void 0 : x.defaultOpenValue)[ce],
    onPickerValueChange: Lt,
    hoverValue: Wt,
    onHover: kn,
    needConfirm: S,
    onSubmit: Qe,
    onOk: De,
    presets: bn,
    onPresetHover: Sn,
    onPresetSubmit: yn,
    onNow: xn,
    cellRender: Pn
  })), je = function(ne, de) {
    var Pe = $t(ne, de);
    Ee(Pe);
  }, Ze = function() {
    He("input");
  }, jt = function(ne, de) {
    var Pe = ee.length, Fe = ee[Pe - 1];
    if (Pe && Fe !== de && S && // Not change index if is not filled
    !M[Fe] && !j(Fe) && ve[Fe]) {
      te.current.focus({
        index: Fe
      });
      return;
    }
    He("input"), ue(!0, {
      inherit: !0
    }), ce !== de && J && !S && l && Qe(null, !0), ke(de), Z(ne, de);
  }, Ca = function(ne, de) {
    if (ue(!1), !S && He() === "input") {
      var Pe = G(ve);
      ct(ce, Pe === null);
    }
    we(ne, de);
  }, ba = function(ne, de) {
    ne.key === "Tab" && Qe(null, !0), v == null || v(ne, de);
  }, Sa = o.useMemo(function() {
    return {
      prefixCls: c,
      locale: Y,
      generateConfig: O,
      button: Q.button,
      input: Q.input
    };
  }, [c, Y, O, Q.button, Q.input]);
  if (lt(function() {
    J && ce !== void 0 && et(null, V, !1);
  }, [J, ce, V]), lt(function() {
    var me = He();
    !J && me === "input" && (ue(!1), Qe(null, !0)), !J && l && !S && me === "panel" && (ue(!0), Qe());
  }, [J]), process.env.NODE_ENV !== "production") {
    var ya = function(ne) {
      return (
        // Value is empty
        !(C != null && C[ne]) && // DefaultValue is empty
        !(p != null && p[ne])
      );
    };
    h.some(function(me, ne) {
      return me && ya(ne) && !M[ne];
    }) && Ge(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
  }
  return /* @__PURE__ */ o.createElement(Xe.Provider, {
    value: Sa
  }, /* @__PURE__ */ o.createElement(Nr, Se({}, _r(a), {
    popupElement: oe,
    popupStyle: d.popup,
    popupClassName: m.popup,
    visible: J,
    onClose: Dn,
    range: !0
  }), /* @__PURE__ */ o.createElement(
    la,
    Se({}, a, {
      // Ref
      ref: te,
      suffixIcon: _,
      activeIndex: Re || J ? ce : null,
      activeHelp: !!yt,
      allHelp: !!yt && gn === "preset",
      focused: Re,
      onFocus: jt,
      onBlur: Ca,
      onKeyDown: ba,
      onSubmit: Qe,
      value: Wt,
      maskFormat: s,
      onChange: je,
      onInputChange: Ze,
      format: u,
      inputReadOnly: D,
      disabled: h,
      open: J,
      onOpenChange: ue,
      onClick: vn,
      onClear: Bt,
      invalid: sn,
      onInvalid: dn,
      onActiveInfo: Cn
    })
  )));
}
var ua = /* @__PURE__ */ o.forwardRef(ri);
process.env.NODE_ENV !== "production" && (ua.displayName = "RefRangePicker");
function ai(e) {
  var t = e.prefixCls, n = e.value, r = e.onRemove, a = e.removeIcon, i = a === void 0 ? "×" : a, l = e.formatDate, u = e.disabled, s = e.maxTagCount, f = e.placeholder, c = "".concat(t, "-selector"), d = "".concat(t, "-selection"), m = "".concat(d, "-overflow");
  function p(v, h) {
    return /* @__PURE__ */ o.createElement("span", {
      className: $e("".concat(d, "-item")),
      title: typeof v == "string" ? v : null
    }, /* @__PURE__ */ o.createElement("span", {
      className: "".concat(d, "-item-content")
    }, v), !u && h && /* @__PURE__ */ o.createElement("span", {
      onMouseDown: function(k) {
        k.preventDefault();
      },
      onClick: h,
      className: "".concat(d, "-item-remove")
    }, i));
  }
  function C(v) {
    var h = l(v), M = function(y) {
      y && y.stopPropagation(), r(v);
    };
    return p(h, M);
  }
  function S(v) {
    var h = "+ ".concat(v.length, " ...");
    return p(h);
  }
  return /* @__PURE__ */ o.createElement("div", {
    className: c
  }, /* @__PURE__ */ o.createElement(Va, {
    prefixCls: m,
    data: n,
    renderItem: C,
    renderRest: S,
    itemKey: function(h) {
      return l(h);
    },
    maxCount: s
  }), !n.length && /* @__PURE__ */ o.createElement("span", {
    className: "".concat(t, "-selection-placeholder")
  }, f));
}
var oi = ["id", "open", "prefix", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex", "removeIcon"];
function ii(e, t) {
  e.id;
  var n = e.open, r = e.prefix, a = e.clearIcon, i = e.suffixIcon;
  e.activeHelp, e.allHelp;
  var l = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown;
  var u = e.locale, s = e.generateConfig, f = e.placeholder, c = e.className, d = e.style, m = e.onClick, p = e.onClear, C = e.internalPicker, S = e.value, v = e.onChange, h = e.onSubmit;
  e.onInputChange;
  var M = e.multiple, k = e.maxTagCount;
  e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var y = e.disabled, I = e.invalid;
  e.inputReadOnly;
  var P = e.direction;
  e.onOpenChange;
  var E = e.onMouseDown;
  e.required, e["aria-required"];
  var L = e.autoFocus, Y = e.tabIndex, O = e.removeIcon, V = xt(e, oi), A = P === "rtl", T = o.useContext(Xe), x = T.prefixCls, g = o.useRef(), b = o.useRef();
  o.useImperativeHandle(t, function() {
    return {
      nativeElement: g.current,
      focus: function(z) {
        var Q;
        (Q = b.current) === null || Q === void 0 || Q.focus(z);
      },
      blur: function() {
        var z;
        (z = b.current) === null || z === void 0 || z.blur();
      }
    };
  });
  var $ = ia(V), w = function(z) {
    v([z]);
  }, H = function(z) {
    var Q = S.filter(function(K) {
      return K && !Le(s, u, K, z, C);
    });
    v(Q), n || h();
  }, R = oa(ie(ie({}, e), {}, {
    onChange: w
  }), function(X) {
    var z = X.valueTexts;
    return {
      value: z[0] || "",
      active: l
    };
  }), N = B(R, 2), D = N[0], _ = N[1], F = !!(a && S.length && !y), q = M ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(ai, {
    prefixCls: x,
    value: S,
    onRemove: H,
    formatDate: _,
    maxTagCount: k,
    disabled: y,
    removeIcon: O,
    placeholder: f
  }), /* @__PURE__ */ o.createElement("input", {
    className: "".concat(x, "-multiple-input"),
    value: S.map(_).join(","),
    ref: b,
    readOnly: !0,
    autoFocus: L,
    tabIndex: Y
  }), /* @__PURE__ */ o.createElement(un, {
    type: "suffix",
    icon: i
  }), F && /* @__PURE__ */ o.createElement(Fn, {
    icon: a,
    onClear: p
  })) : /* @__PURE__ */ o.createElement(nn, Se({
    ref: b
  }, D(), {
    autoFocus: L,
    tabIndex: Y,
    suffixIcon: i,
    clearIcon: F && /* @__PURE__ */ o.createElement(Fn, {
      icon: a,
      onClear: p
    }),
    showActiveCls: !1
  }));
  return /* @__PURE__ */ o.createElement("div", Se({}, $, {
    className: $e(x, pe(pe(pe(pe(pe({}, "".concat(x, "-multiple"), M), "".concat(x, "-focused"), l), "".concat(x, "-disabled"), y), "".concat(x, "-invalid"), I), "".concat(x, "-rtl"), A), c),
    style: d,
    ref: g,
    onClick: m,
    onMouseDown: function(z) {
      var Q, K = z.target;
      K !== ((Q = b.current) === null || Q === void 0 ? void 0 : Q.inputElement) && z.preventDefault(), E == null || E(z);
    }
  }), r && /* @__PURE__ */ o.createElement("div", {
    className: "".concat(x, "-prefix")
  }, r), q);
}
var ca = /* @__PURE__ */ o.forwardRef(ii);
process.env.NODE_ENV !== "production" && (ca.displayName = "SingleSelector");
function li(e, t) {
  var n = jr(e), r = B(n, 6), a = r[0], i = r[1], l = r[2], u = r[3], s = r[4], f = r[5], c = a, d = c.prefixCls, m = c.styles, p = c.classNames, C = c.order, S = c.defaultValue, v = c.value, h = c.needConfirm, M = c.onChange, k = c.onKeyDown, y = c.disabled, I = c.disabledDate, P = c.minDate, E = c.maxDate, L = c.defaultOpen, Y = c.open, O = c.onOpenChange, V = c.locale, A = c.generateConfig, T = c.picker, x = c.showNow, g = c.showToday, b = c.showTime, $ = c.mode, w = c.onPanelChange, H = c.onCalendarChange, R = c.onOk, N = c.multiple, D = c.defaultPickerValue, _ = c.pickerValue, F = c.onPickerValueChange, q = c.inputReadOnly, X = c.suffixIcon, z = c.removeIcon, Q = c.onFocus, K = c.onBlur, W = c.presets, U = c.components, re = c.cellRender, te = c.dateRender, le = c.monthCellRender, ge = c.onClick, J = Ur(t);
  function Ce(se) {
    return se === null ? null : N ? se : se[0];
  }
  var ue = na(A, V, i), xe = zr(Y, L, [y], O), fe = B(xe, 2), be = fe[0], ye = fe[1], Ie = function(oe, je, Ze) {
    if (H) {
      var jt = ie({}, Ze);
      delete jt.range, H(Ce(oe), Ce(je), jt);
    }
  }, Ee = function(oe) {
    R == null || R(Ce(oe));
  }, De = Jr(A, V, u, !1, C, S, v, Ie, Ee), ve = B(De, 5), Ve = ve[0], Ne = ve[1], Re = ve[2], Te = ve[3], He = ve[4], ce = Re(), ke = Kr([y]), G = B(ke, 4), ee = G[0], ae = G[1], j = G[2], Z = G[3], we = function(oe) {
    ae(!0), Q == null || Q(oe, {});
  }, Me = function(oe) {
    ae(!1), K == null || K(oe, {});
  }, Oe = rt(T, {
    value: $
  }), qe = B(Oe, 2), We = qe[0], Ke = qe[1], Ue = We === "date" && b ? "datetime" : We, Ae = ta(T, We, x, g), Je = M && function(se, oe) {
    M(Ce(se), Ce(oe));
  }, Ct = ea(
    ie(ie({}, a), {}, {
      onChange: Je
    }),
    Ve,
    Ne,
    Re,
    Te,
    [],
    //disabled,
    u,
    ee,
    be,
    f
  ), bt = B(Ct, 2), ot = bt[1], ct = Vr(ce, f), st = B(ct, 2), dt = st[0], cn = st[1], Ft = o.useMemo(function() {
    return dt.some(function(se) {
      return se;
    });
  }, [dt]), sn = function(oe, je) {
    if (F) {
      var Ze = ie(ie({}, je), {}, {
        mode: je.mode[0]
      });
      delete Ze.range, F(oe[0], Ze);
    }
  }, dn = Gr(
    A,
    V,
    ce,
    [We],
    be,
    Z,
    i,
    !1,
    // multiplePanel,
    D,
    _,
    ht(b == null ? void 0 : b.defaultOpenValue),
    sn,
    P,
    E
  ), Yt = B(dn, 2), At = Yt[0], fn = Yt[1], Lt = Ye(function(se, oe, je) {
    if (Ke(oe), w && je !== !1) {
      var Ze = se || ce[ce.length - 1];
      w(Ze, oe);
    }
  }), et = function() {
    ot(Re()), ye(!1, {
      force: !0
    });
  }, $t = function(oe) {
    !y && !J.current.nativeElement.contains(document.activeElement) && J.current.focus(), ye(!0), ge == null || ge(oe);
  }, Qe = function() {
    ot(null), ye(!1, {
      force: !0
    });
  }, vn = o.useState(null), Bt = B(vn, 2), mn = Bt[0], Dt = Bt[1], gn = o.useState(null), Pt = B(gn, 2), tt = Pt[0], St = Pt[1], yt = o.useMemo(function() {
    var se = [tt].concat(Be(ce)).filter(function(oe) {
      return oe;
    });
    return N ? se : se.slice(0, 1);
  }, [ce, tt, N]), It = o.useMemo(function() {
    return !N && tt ? [tt] : ce.filter(function(se) {
      return se;
    });
  }, [ce, tt, N]);
  o.useEffect(function() {
    be || St(null);
  }, [be]);
  var Wt = qr(W), hn = function(oe) {
    St(oe), Dt("preset");
  }, Et = function(oe) {
    var je = N ? ue(Re(), oe) : [oe], Ze = ot(je);
    Ze && !N && ye(!1, {
      force: !0
    });
  }, pn = function(oe) {
    Et(oe);
  }, Cn = function(oe) {
    St(oe), Dt("cell");
  }, bn = function(oe) {
    ye(!0), we(oe);
  }, Sn = function(oe) {
    if (j("panel"), !(N && Ue !== T)) {
      var je = N ? ue(Re(), oe) : [oe];
      Te(je), !h && !l && i === Ue && et();
    }
  }, yn = function() {
    ye(!1);
  }, xn = jn(re, te, le), kn = o.useMemo(function() {
    var se = Bn(a, !1), oe = sr(a, [].concat(Be(Object.keys(se)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return ie(ie({}, oe), {}, {
      multiple: a.multiple
    });
  }, [a]), wn = /* @__PURE__ */ o.createElement(aa, Se({}, kn, {
    showNow: Ae,
    showTime: b,
    disabledDate: I,
    onFocus: bn,
    onBlur: Me,
    picker: T,
    mode: We,
    internalMode: Ue,
    onPanelChange: Lt,
    format: s,
    value: ce,
    isInvalid: f,
    onChange: null,
    onSelect: Sn,
    pickerValue: At,
    defaultOpenValue: b == null ? void 0 : b.defaultOpenValue,
    onPickerValueChange: fn,
    hoverValue: yt,
    onHover: Cn,
    needConfirm: h,
    onSubmit: et,
    onOk: He,
    presets: Wt,
    onPresetHover: hn,
    onPresetSubmit: Et,
    onNow: pn,
    cellRender: xn
  })), Mn = function(oe) {
    Te(oe);
  }, $n = function() {
    j("input");
  }, Dn = function(oe) {
    j("input"), ye(!0, {
      inherit: !0
    }), we(oe);
  }, Pn = function(oe) {
    ye(!1), Me(oe);
  }, In = function(oe, je) {
    oe.key === "Tab" && et(), k == null || k(oe, je);
  }, En = o.useMemo(function() {
    return {
      prefixCls: d,
      locale: V,
      generateConfig: A,
      button: U.button,
      input: U.input
    };
  }, [d, V, A, U.button, U.input]);
  return lt(function() {
    be && Z !== void 0 && Lt(null, T, !1);
  }, [be, Z, T]), lt(function() {
    var se = j();
    !be && se === "input" && (ye(!1), et()), !be && l && !h && se === "panel" && et();
  }, [be]), /* @__PURE__ */ o.createElement(Xe.Provider, {
    value: En
  }, /* @__PURE__ */ o.createElement(Nr, Se({}, _r(a), {
    popupElement: wn,
    popupStyle: m.popup,
    popupClassName: p.popup,
    visible: be,
    onClose: yn
  }), /* @__PURE__ */ o.createElement(
    ca,
    Se({}, a, {
      // Ref
      ref: J,
      suffixIcon: X,
      removeIcon: z,
      activeHelp: !!tt,
      allHelp: !!tt && mn === "preset",
      focused: ee,
      onFocus: Dn,
      onBlur: Pn,
      onKeyDown: In,
      onSubmit: et,
      value: It,
      maskFormat: s,
      onChange: Mn,
      onInputChange: $n,
      internalPicker: i,
      format: u,
      inputReadOnly: q,
      disabled: y,
      open: be,
      onOpenChange: ye,
      onClick: $t,
      onClear: Qe,
      invalid: Ft,
      onInvalid: function(oe) {
        cn(oe, 0);
      }
    })
  )));
}
var sa = /* @__PURE__ */ o.forwardRef(li);
process.env.NODE_ENV !== "production" && (sa.displayName = "RefPicker");
const _n = (e, t) => {
  const {
    componentCls: n,
    controlHeight: r
  } = e, a = t ? `${n}-${t}` : "", i = Ga(e);
  return [
    // genSelectionStyle(token, suffix),
    {
      [`${n}-multiple${a}`]: {
        paddingBlock: i.containerPadding,
        paddingInlineStart: i.basePadding,
        minHeight: r,
        // ======================== Selections ========================
        [`${n}-selection-item`]: {
          height: i.itemHeight,
          lineHeight: he(i.itemLineHeight)
        }
      }
    }
  ];
}, ui = (e) => {
  const {
    componentCls: t,
    calc: n,
    lineWidth: r
  } = e, a = Hn(e, {
    fontHeight: e.fontSize,
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS,
    controlHeight: e.controlHeightSM
  }), i = Hn(e, {
    fontHeight: n(e.multipleItemHeightLG).sub(n(r).mul(2).equal()).equal(),
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius,
    controlHeight: e.controlHeightLG
  });
  return [
    // ======================== Size ========================
    _n(a, "small"),
    _n(e),
    _n(i, "large"),
    // ====================== Selection ======================
    {
      [`${t}${t}-multiple`]: Object.assign(Object.assign({
        width: "100%",
        cursor: "text",
        // ==================== Selector =====================
        [`${t}-selector`]: {
          flex: "auto",
          padding: 0,
          position: "relative",
          "&:after": {
            margin: 0
          },
          // ================== placeholder ==================
          [`${t}-selection-placeholder`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: e.inputPaddingHorizontalBase,
            insetInlineEnd: 0,
            transform: "translateY(-50%)",
            transition: `all ${e.motionDurationSlow}`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 1,
            color: e.colorTextPlaceholder,
            pointerEvents: "none"
          }
        }
      }, Ka(e)), {
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${t}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      })
    }
  ];
}, ci = (e) => {
  const {
    pickerCellCls: t,
    pickerCellInnerCls: n,
    cellHeight: r,
    borderRadiusSM: a,
    motionDurationMid: i,
    cellHoverBg: l,
    lineWidth: u,
    lineType: s,
    colorPrimary: f,
    cellActiveWithRangeBg: c,
    colorTextLightSolid: d,
    colorTextDisabled: m,
    cellBgDisabled: p,
    colorFillSecondary: C
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: r,
      transform: "translateY(-50%)",
      content: '""',
      pointerEvents: "none"
    },
    // >>> Default
    [n]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: r,
      height: r,
      lineHeight: he(r),
      borderRadius: a,
      transition: `background ${i}`
    },
    // >>> Hover
    [`&:hover:not(${t}-in-view):not(${t}-disabled),
    &:hover:not(${t}-selected):not(${t}-range-start):not(${t}-range-end):not(${t}-disabled)`]: {
      [n]: {
        background: l
      }
    },
    // >>> Today
    [`&-in-view${t}-today ${n}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${he(u)} ${s} ${f}`,
        borderRadius: a,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${t}-in-range,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      position: "relative",
      [`&:not(${t}-disabled):before`]: {
        background: c
      }
    },
    // >>> Selected
    [`&-in-view${t}-selected,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      [`&:not(${t}-disabled) ${n}`]: {
        color: d,
        background: f
      },
      [`&${t}-disabled ${n}`]: {
        background: C
      }
    },
    [`&-in-view${t}-range-start:not(${t}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${t}-range-end:not(${t}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${t}-range-start:not(${t}-range-end) ${n}`]: {
      borderStartStartRadius: a,
      borderEndStartRadius: a,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${t}-range-end:not(${t}-range-start) ${n}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: a,
      borderEndEndRadius: a
    },
    // >>> Disabled
    "&-disabled": {
      color: m,
      cursor: "not-allowed",
      [n]: {
        background: "transparent"
      },
      "&::before": {
        background: p
      }
    },
    [`&-disabled${t}-today ${n}::before`]: {
      borderColor: m
    }
  };
}, si = (e) => {
  const {
    componentCls: t,
    pickerCellCls: n,
    pickerCellInnerCls: r,
    pickerYearMonthCellWidth: a,
    pickerControlIconSize: i,
    cellWidth: l,
    paddingSM: u,
    paddingXS: s,
    paddingXXS: f,
    colorBgContainer: c,
    lineWidth: d,
    lineType: m,
    borderRadiusLG: p,
    colorPrimary: C,
    colorTextHeading: S,
    colorSplit: v,
    pickerControlIconBorderWidth: h,
    colorIcon: M,
    textHeight: k,
    motionDurationMid: y,
    colorIconHover: I,
    fontWeightStrong: P,
    cellHeight: E,
    pickerCellPaddingVertical: L,
    colorTextDisabled: Y,
    colorText: O,
    fontSize: V,
    motionDurationSlow: A,
    withoutTimeCellHeight: T,
    pickerQuarterPanelContentHeight: x,
    borderRadiusSM: g,
    colorTextLightSolid: b,
    cellHoverBg: $,
    timeColumnHeight: w,
    timeColumnWidth: H,
    timeCellHeight: R,
    controlItemBgActive: N,
    marginXXS: D,
    pickerDatePanelPaddingHorizontal: _,
    pickerControlIconMargin: F
  } = e, q = e.calc(l).mul(7).add(e.calc(_).mul(2)).equal();
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: c,
        borderRadius: p,
        outline: "none",
        "&-focused": {
          borderColor: C
        },
        "&-rtl": {
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          },
          [`${t}-time-panel`]: {
            [`${t}-content`]: {
              direction: "ltr",
              "> *": {
                direction: "rtl"
              }
            }
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: q
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${he(s)}`,
        color: S,
        borderBottom: `${he(d)} ${m} ${v}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: M,
          lineHeight: he(k),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${y}`,
          fontSize: "inherit",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          "&:empty": {
            display: "none"
          }
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: V,
          "&:hover": {
            color: I
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: P,
          lineHeight: he(k),
          "> button": {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: s
            },
            "&:hover": {
              color: C
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        width: i,
        height: i,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockStartWidth: h,
          borderInlineStartWidth: h,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: F,
          insetInlineStart: F,
          display: "inline-block",
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockStartWidth: h,
          borderInlineStartWidth: h,
          content: '""'
        }
      },
      "&-prev-icon, &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon, &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: E,
          fontWeight: "normal"
        },
        th: {
          height: e.calc(E).add(e.calc(L).mul(2)).equal(),
          color: O,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${he(L)} 0`,
        color: Y,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: O
        }
      }, ci(e)),
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-content`]: {
          height: e.calc(T).mul(4).equal()
        },
        [r]: {
          padding: `0 ${he(s)}`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: x
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [r]: {
          padding: `0 ${he(e.calc(s).div(2).equal())}`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-body`]: {
          padding: `0 ${he(s)}`
        },
        [r]: {
          width: a
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${he(s)} ${he(_)}`
        },
        [`${t}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        // Clear cell style
        [`${t}-cell`]: {
          [`&:hover ${r},
            &-selected ${r},
            ${r}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${y}`
            },
            "&:first-child:before": {
              borderStartStartRadius: g,
              borderEndStartRadius: g
            },
            "&:last-child:before": {
              borderStartEndRadius: g,
              borderEndEndRadius: g
            }
          },
          "&:hover td:before": {
            background: $
          },
          "&-range-start td, &-range-end td, &-selected td, &-hover td": {
            // Rise priority to override hover style
            [`&${n}`]: {
              "&:before": {
                background: C
              },
              [`&${t}-cell-week`]: {
                color: new en(b).setA(0.5).toHexString()
              },
              [r]: {
                color: b
              }
            }
          },
          "&-range-hover td:before": {
            background: N
          }
        }
      },
      // >>> ShowWeek
      "&-week-panel, &-date-panel-show-week": {
        [`${t}-body`]: {
          padding: `${he(s)} ${he(u)}`
        },
        [`${t}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${he(d)} ${m} ${v}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${A}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: w
        },
        "&-column": {
          flex: "1 0 auto",
          width: H,
          margin: `${he(f)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${y}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: e.colorTextTertiary,
            borderRadius: e.borderRadiusSM
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${e.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: `calc(100% - ${he(R)})`,
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${he(d)} ${m} ${v}`
          },
          "&-active": {
            background: new en(N).setA(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: D,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: e.calc(H).sub(e.calc(D).mul(2)).equal(),
                height: R,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: e.calc(H).sub(R).div(2).equal(),
                color: O,
                lineHeight: he(R),
                borderRadius: g,
                cursor: "pointer",
                transition: `background ${y}`,
                "&:hover": {
                  background: $
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: N
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: Y,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      }
    }
  };
}, di = (e) => {
  const {
    componentCls: t,
    textHeight: n,
    lineWidth: r,
    paddingSM: a,
    antCls: i,
    colorPrimary: l,
    cellActiveWithRangeBg: u,
    colorPrimaryBorder: s,
    lineType: f,
    colorSplit: c
  } = e;
  return {
    [`${t}-dropdown`]: {
      // ======================== Footer ========================
      [`${t}-footer`]: {
        borderTop: `${he(r)} ${f} ${c}`,
        "&-extra": {
          padding: `0 ${he(a)}`,
          lineHeight: he(e.calc(n).sub(e.calc(r).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${he(r)} ${f} ${c}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${t}-panels + ${t}-footer ${t}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${t}-ranges`]: {
        marginBlock: 0,
        paddingInline: he(a),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: he(e.calc(n).sub(e.calc(r).mul(2)).equal()),
          display: "inline-block"
        },
        [`${t}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: e.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${t}-preset > ${i}-tag-blue`]: {
          color: l,
          background: u,
          borderColor: s,
          cursor: "pointer"
        },
        [`${t}-ok`]: {
          paddingBlock: e.calc(r).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
}, fi = (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    paddingXXS: r,
    padding: a
  } = e;
  return {
    pickerCellCls: `${t}-cell`,
    pickerCellInnerCls: `${t}-cell-inner`,
    pickerYearMonthCellWidth: e.calc(n).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: e.calc(n).mul(1.4).equal(),
    pickerCellPaddingVertical: e.calc(r).add(e.calc(r).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: e.calc(a).add(e.calc(r).div(2)).equal()
    // 18 in normal
  };
}, vi = (e) => {
  const {
    colorBgContainerDisabled: t,
    controlHeight: n,
    controlHeightSM: r,
    controlHeightLG: a,
    paddingXXS: i,
    lineWidth: l
  } = e, u = i * 2, s = l * 2, f = Math.min(n - u, n - s), c = Math.min(r - u, r - s), d = Math.min(a - u, a - s);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(i / 2),
    cellHoverBg: e.controlItemBgHover,
    cellActiveWithRangeBg: e.controlItemBgActive,
    cellHoverWithRangeBg: new en(e.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new en(e.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: t,
    timeColumnWidth: a * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: r * 1.5,
    cellHeight: r,
    textHeight: a,
    withoutTimeCellHeight: a * 1.65,
    multipleItemBg: e.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: f,
    multipleItemHeightSM: c,
    multipleItemHeightLG: d,
    multipleSelectorBgDisabled: t,
    multipleItemColorDisabled: e.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
}, mi = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, Aa(e)), vi(e)), Ra(e)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
}), gi = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: [
      Object.assign(Object.assign(Object.assign(Object.assign({}, La(e)), Ba(e)), Wa(e)), ja(e)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${he(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.colorBgContainer,
            border: `${he(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${he(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-underlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${he(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
}, Vn = (e, t, n, r) => {
  const a = e.calc(n).add(2).equal(), i = e.max(e.calc(t).sub(a).div(2).equal(), 0), l = e.max(e.calc(t).sub(a).sub(i).equal(), 0);
  return {
    padding: `${he(i)} ${he(r)} ${he(l)}`
  };
}, hi = (e) => {
  const {
    componentCls: t,
    colorError: n,
    colorWarning: r
  } = e;
  return {
    [`${t}:not(${t}-disabled):not([disabled])`]: {
      [`&${t}-status-error`]: {
        [`${t}-active-bar`]: {
          background: n
        }
      },
      [`&${t}-status-warning`]: {
        [`${t}-active-bar`]: {
          background: r
        }
      }
    }
  };
}, pi = (e) => {
  const {
    componentCls: t,
    antCls: n,
    controlHeight: r,
    paddingInline: a,
    lineWidth: i,
    lineType: l,
    colorBorder: u,
    borderRadius: s,
    motionDurationMid: f,
    colorTextDisabled: c,
    colorTextPlaceholder: d,
    controlHeightLG: m,
    fontSizeLG: p,
    controlHeightSM: C,
    paddingInlineSM: S,
    paddingXS: v,
    marginXS: h,
    colorIcon: M,
    lineWidthBold: k,
    colorPrimary: y,
    motionDurationSlow: I,
    zIndexPopup: P,
    paddingXXS: E,
    sizePopupArrow: L,
    colorBgElevated: Y,
    borderRadiusLG: O,
    boxShadowSecondary: V,
    borderRadiusSM: A,
    colorSplit: T,
    cellHoverBg: x,
    presetsWidth: g,
    presetsMaxWidth: b,
    boxShadowPopoverArrow: $,
    fontHeight: w,
    fontHeightLG: H,
    lineHeightLG: R
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign({}, Qn(e)), Vn(e, r, w, a)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: s,
        transition: `border ${f}, box-shadow ${f}, background ${f}`,
        [`${t}-prefix`]: {
          flex: "0 0 auto",
          marginInlineEnd: e.inputAffixPadding
        },
        // ======================== Input =========================
        [`${t}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: e.fontSize,
            lineHeight: e.lineHeight,
            transition: `all ${f}`
          }, Ua(d)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: c,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: d
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, Vn(e, m, H, a)), {
          [`${t}-input > input`]: {
            fontSize: p,
            lineHeight: R
          }
        }),
        "&-small": Object.assign({}, Vn(e, C, w, S)),
        [`${t}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: e.calc(v).div(2).equal(),
          color: c,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${f}, color ${f}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: h
            }
          }
        },
        [`${t}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: c,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${f}, color ${f}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: M
          }
        },
        "&:hover": {
          [`${t}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${t}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${t}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: p,
          color: c,
          fontSize: p,
          verticalAlign: "top",
          cursor: "default",
          [`${t}-focused &`]: {
            color: M
          },
          [`${t}-range-separator &`]: {
            [`${t}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${t}-active-bar`]: {
            bottom: e.calc(i).mul(-1).equal(),
            height: k,
            background: y,
            opacity: 0,
            transition: `all ${I} ease-out`,
            pointerEvents: "none"
          },
          [`&${t}-focused`]: {
            [`${t}-active-bar`]: {
              opacity: 1
            }
          },
          [`${t}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${he(v)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${t}-clear`]: {
            insetInlineEnd: a
          },
          [`&${t}-small`]: {
            [`${t}-clear`]: {
              insetInlineEnd: S
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, Qn(e)), si(e)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: P,
          [`&${t}-dropdown-hidden`]: {
            display: "none"
          },
          "&-rtl": {
            direction: "rtl"
          },
          [`&${t}-dropdown-placement-bottomLeft,
            &${t}-dropdown-placement-bottomRight`]: {
            [`${t}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${t}-dropdown-placement-topLeft,
            &${t}-dropdown-placement-topRight`]: {
            [`${t}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${n}-slide-up-appear, &${n}-slide-up-enter`]: {
            [`${t}-range-arrow${t}-range-arrow`]: {
              transition: "none"
            }
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topRight`]: {
            animationName: Ha
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Ta
          },
          // https://github.com/ant-design/ant-design/issues/48727
          [`&${n}-slide-up-leave ${t}-panel-container`]: {
            pointerEvents: "none"
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topRight`]: {
            animationName: Fa
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Ya
          },
          // Time picker with additional style
          [`${t}-panel > ${t}-time-panel`]: {
            paddingTop: E
          },
          // ======================== Ranges ========================
          [`${t}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${t}-range-arrow`]: Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            paddingInline: e.calc(a).mul(1.5).equal(),
            boxSizing: "content-box",
            transition: `all ${I} ease-out`
          }, Oa(e, Y, $)), {
            "&:before": {
              insetInlineStart: e.calc(a).mul(1.5).equal()
            }
          }),
          [`${t}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: Y,
            borderRadius: O,
            boxShadow: V,
            transition: `margin ${I}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${t}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${t}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: g,
              maxWidth: b,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: v,
                borderInlineEnd: `${he(i)} ${l} ${T}`,
                li: Object.assign(Object.assign({}, Ia), {
                  borderRadius: A,
                  paddingInline: v,
                  paddingBlock: e.calc(C).sub(w).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${I}`,
                  "+ li": {
                    marginTop: h
                  },
                  "&:hover": {
                    background: x
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${t}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${t}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${t}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${t}-content, table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: u
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${he(e.calc(L).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-separator`]: {
            transform: "scale(-1, 1)"
          },
          [`${t}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    Zn(e, "slide-up"),
    Zn(e, "slide-down"),
    Jn(e, "move-up"),
    Jn(e, "move-down")
  ];
}, da = Pa("DatePicker", (e) => {
  const t = Hn(za(e), fi(e), {
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [
    di(t),
    pi(t),
    gi(t),
    hi(t),
    ui(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    qa(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, mi);
var Ci = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" }, bi = function(t, n) {
  return /* @__PURE__ */ o.createElement(Ln, Se({}, t, {
    ref: n,
    icon: Ci
  }));
}, Gn = /* @__PURE__ */ o.forwardRef(bi);
process.env.NODE_ENV !== "production" && (Gn.displayName = "CalendarOutlined");
var Si = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" }, yi = function(t, n) {
  return /* @__PURE__ */ o.createElement(Ln, Se({}, t, {
    ref: n,
    icon: Si
  }));
}, Xn = /* @__PURE__ */ o.forwardRef(yi);
process.env.NODE_ENV !== "production" && (Xn.displayName = "ClockCircleOutlined");
var xi = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" }, ki = function(t, n) {
  return /* @__PURE__ */ o.createElement(Ln, Se({}, t, {
    ref: n,
    icon: xi
  }));
}, fa = /* @__PURE__ */ o.forwardRef(ki);
process.env.NODE_ENV !== "production" && (fa.displayName = "SwapRightOutlined");
function wi(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function Mi(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function va(e, t) {
  const {
    allowClear: n = !0
  } = e, {
    clearIcon: r,
    removeIcon: a
  } = Xa(Object.assign(Object.assign({}, e), {
    prefixCls: t,
    componentName: "DatePicker"
  }));
  return [o.useMemo(() => n === !1 ? !1 : Object.assign({
    clearIcon: r
  }, n === !0 ? {} : n), [n, r]), a];
}
const [$i, Di] = ["week", "WeekPicker"], [Pi, Ii] = ["month", "MonthPicker"], [Ei, Ni] = ["year", "YearPicker"], [Ri, Oi] = ["quarter", "QuarterPicker"], [Yn, ar] = ["time", "TimePicker"], _i = (e) => /* @__PURE__ */ o.createElement(Qa, Object.assign({
  size: "small",
  type: "primary"
}, e));
function ma(e) {
  return wa(() => Object.assign({
    button: _i
  }, e), [e]);
}
function ga(e, ...t) {
  const n = e || {};
  return t.reduce((r, a) => (Object.keys(a || {}).forEach((i) => {
    const l = n[i], u = a[i];
    if (l && typeof l == "object")
      if (u && typeof u == "object")
        r[i] = ga(l, r[i], u);
      else {
        const {
          _default: s
        } = l;
        r[i] = r[i] || {}, r[i][s] = $e(r[i][s], u);
      }
    else
      r[i] = $e(r[i], u);
  }), r), {});
}
function Vi(e, ...t) {
  return o.useMemo(() => ga.apply(void 0, [e].concat(t)), [t]);
}
function Hi(...e) {
  return o.useMemo(() => e.reduce((t, n = {}) => (Object.keys(n).forEach((r) => {
    t[r] = Object.assign(Object.assign({}, t[r]), n[r]);
  }), t), {}), [e]);
}
function An(e, t) {
  const n = Object.assign({}, e);
  return Object.keys(t).forEach((r) => {
    if (r !== "_default") {
      const a = t[r], i = n[r] || {};
      n[r] = a ? An(i, a) : i;
    }
  }), n;
}
function Ti(e, t, n) {
  const r = Vi.apply(void 0, [n].concat(Be(e))), a = Hi.apply(void 0, Be(t));
  return o.useMemo(() => [An(r, n), An(a, n)], [r, a]);
}
const ha = (e, t, n, r, a) => {
  const {
    classNames: i,
    styles: l
  } = Ea(e), [u, s] = Ti([i, t], [l, n], {
    popup: {
      _default: "root"
    }
  });
  return o.useMemo(() => {
    var f, c;
    const d = Object.assign(Object.assign({}, u), {
      popup: Object.assign(Object.assign({}, u.popup), {
        root: $e((f = u.popup) === null || f === void 0 ? void 0 : f.root, r)
      })
    }), m = Object.assign(Object.assign({}, s), {
      popup: Object.assign(Object.assign({}, s.popup), {
        root: Object.assign(Object.assign({}, (c = s.popup) === null || c === void 0 ? void 0 : c.root), a)
      })
    });
    return [d, m];
  }, [u, s, r, a]);
};
var Fi = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Yi = (e) => {
  const t = /* @__PURE__ */ ir((n, r) => {
    var a;
    const {
      prefixCls: i,
      getPopupContainer: l,
      components: u,
      className: s,
      style: f,
      placement: c,
      size: d,
      disabled: m,
      bordered: p = !0,
      placeholder: C,
      popupStyle: S,
      popupClassName: v,
      dropdownClassName: h,
      status: M,
      rootClassName: k,
      variant: y,
      picker: I,
      styles: P,
      classNames: E
    } = n, L = Fi(n, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant", "picker", "styles", "classNames"]), Y = I === Yn ? "timePicker" : "datePicker", O = o.useRef(null), {
      getPrefixCls: V,
      direction: A,
      getPopupContainer: T,
      rangePicker: x
    } = Jt(ur), g = V("picker", i), {
      compactSize: b,
      compactItemClassnames: $
    } = fr(g, A), w = V(), [H, R] = xr("rangePicker", y, p), N = vr(g), [D, _, F] = da(g, N);
    if (process.env.NODE_ENV !== "production") {
      const fe = br("DatePicker.RangePicker");
      Object.entries({
        dropdownClassName: "classNames.popup.root",
        popupClassName: "classNames.popup.root",
        popupStyle: "styles.popup.root",
        bordered: "variant",
        onSelect: "onCalendarChange"
      }).forEach(([ye, Ie]) => {
        fe.deprecated(!(ye in n), ye, Ie);
      });
    }
    const [q, X] = ha(Y, E, P, v || h, S), [z] = va(n, g), Q = ma(u), K = cr((fe) => {
      var be;
      return (be = d ?? b) !== null && be !== void 0 ? be : fe;
    }), W = o.useContext(Sr), U = m ?? W, re = Jt(mr), {
      hasFeedback: te,
      status: le,
      feedbackIcon: ge
    } = re, J = /* @__PURE__ */ o.createElement(o.Fragment, null, I === Yn ? /* @__PURE__ */ o.createElement(Xn, null) : /* @__PURE__ */ o.createElement(Gn, null), te && ge);
    lr(r, () => O.current);
    const [Ce] = kr("Calendar", yr), ue = Object.assign(Object.assign({}, Ce), n.locale), [xe] = hr("DatePicker", (a = X.popup.root) === null || a === void 0 ? void 0 : a.zIndex);
    return D(/* @__PURE__ */ o.createElement(gr, {
      space: !0
    }, /* @__PURE__ */ o.createElement(ua, Object.assign({
      separator: /* @__PURE__ */ o.createElement("span", {
        "aria-label": "to",
        className: `${g}-separator`
      }, /* @__PURE__ */ o.createElement(fa, null)),
      disabled: U,
      ref: O,
      placement: c,
      placeholder: Mi(ue, I, C),
      suffixIcon: J,
      prevIcon: /* @__PURE__ */ o.createElement("span", {
        className: `${g}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ o.createElement("span", {
        className: `${g}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ o.createElement("span", {
        className: `${g}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ o.createElement("span", {
        className: `${g}-super-next-icon`
      }),
      transitionName: `${w}-slide-up`,
      picker: I
    }, L, {
      className: $e({
        [`${g}-${K}`]: K,
        [`${g}-${H}`]: R
      }, pr(g, Cr(le, M), te), _, $, s, x == null ? void 0 : x.className, F, N, k, q.root),
      style: Object.assign(Object.assign(Object.assign({}, x == null ? void 0 : x.style), f), X.root),
      locale: ue.lang,
      prefixCls: g,
      getPopupContainer: l || T,
      generateConfig: e,
      components: Q,
      direction: A,
      classNames: {
        popup: $e(_, F, N, k, q.popup.root)
      },
      styles: {
        popup: Object.assign(Object.assign({}, X.popup.root), {
          zIndex: xe
        })
      },
      allowClear: z
    }))));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "RangePicker"), t;
};
var Ai = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Li = (e) => {
  const t = (s, f) => {
    const c = f === ar ? "timePicker" : "datePicker", d = /* @__PURE__ */ ir((m, p) => {
      var C;
      const {
        prefixCls: S,
        getPopupContainer: v,
        components: h,
        style: M,
        className: k,
        rootClassName: y,
        size: I,
        bordered: P,
        placement: E,
        placeholder: L,
        popupStyle: Y,
        popupClassName: O,
        dropdownClassName: V,
        disabled: A,
        status: T,
        variant: x,
        onCalendarChange: g,
        styles: b,
        classNames: $
      } = m, w = Ai(m, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange", "styles", "classNames"]), {
        getPrefixCls: H,
        direction: R,
        getPopupContainer: N,
        // Consume different styles according to different names
        [c]: D
      } = Jt(ur), _ = H("picker", S), {
        compactSize: F,
        compactItemClassnames: q
      } = fr(_, R), X = o.useRef(null), [z, Q] = xr("datePicker", x, P), K = vr(_), [W, U, re] = da(_, K);
      lr(p, () => X.current);
      const te = {
        showToday: !0
      }, le = s || m.picker, ge = H(), {
        onSelect: J,
        multiple: Ce
      } = w, ue = J && s === "time" && !Ce, xe = (ae, j, Z) => {
        g == null || g(ae, j, Z), ue && J(ae);
      };
      if (process.env.NODE_ENV !== "production") {
        const ae = br(f || "DatePicker");
        process.env.NODE_ENV !== "production" && ae(s !== "quarter", "deprecated", `DatePicker.${f} is legacy usage. Please use DatePicker[picker='${s}'] directly.`), Object.entries({
          dropdownClassName: "classNames.popup.root",
          popupClassName: "classNames.popup.root",
          popupStyle: "styles.popup.root",
          bordered: "variant",
          onSelect: "onCalendarChange"
        }).forEach(([Z, we]) => {
          ae.deprecated(!(Z in m), Z, we);
        });
      }
      const [fe, be] = ha(c, $, b, O || V, Y), [ye, Ie] = va(m, _), Ee = ma(h), De = cr((ae) => {
        var j;
        return (j = I ?? F) !== null && j !== void 0 ? j : ae;
      }), ve = o.useContext(Sr), Ve = A ?? ve, Ne = Jt(mr), {
        hasFeedback: Re,
        status: Te,
        feedbackIcon: He
      } = Ne, ce = /* @__PURE__ */ o.createElement(o.Fragment, null, le === "time" ? /* @__PURE__ */ o.createElement(Xn, null) : /* @__PURE__ */ o.createElement(Gn, null), Re && He), [ke] = kr("DatePicker", yr), G = Object.assign(Object.assign({}, ke), m.locale), [ee] = hr("DatePicker", (C = be.popup.root) === null || C === void 0 ? void 0 : C.zIndex);
      return W(/* @__PURE__ */ o.createElement(gr, {
        space: !0
      }, /* @__PURE__ */ o.createElement(sa, Object.assign({
        ref: X,
        placeholder: wi(G, le, L),
        suffixIcon: ce,
        placement: E,
        prevIcon: /* @__PURE__ */ o.createElement("span", {
          className: `${_}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ o.createElement("span", {
          className: `${_}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ o.createElement("span", {
          className: `${_}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ o.createElement("span", {
          className: `${_}-super-next-icon`
        }),
        transitionName: `${ge}-slide-up`,
        picker: s,
        onCalendarChange: xe
      }, te, w, {
        locale: G.lang,
        className: $e({
          [`${_}-${De}`]: De,
          [`${_}-${z}`]: Q
        }, pr(_, Cr(Te, T), Re), U, q, D == null ? void 0 : D.className, k, re, K, y, fe.root),
        style: Object.assign(Object.assign(Object.assign({}, D == null ? void 0 : D.style), M), be.root),
        prefixCls: _,
        getPopupContainer: v || N,
        generateConfig: e,
        components: Ee,
        direction: R,
        disabled: Ve,
        classNames: {
          popup: $e(U, re, K, y, fe.popup.root)
        },
        styles: {
          popup: Object.assign(Object.assign({}, be.popup.root), {
            zIndex: ee
          })
        },
        allowClear: ye,
        removeIcon: Ie
      }))));
    });
    return process.env.NODE_ENV !== "production" && f && (d.displayName = f), d;
  }, n = t(), r = t($i, Di), a = t(Pi, Ii), i = t(Ei, Ni), l = t(Ri, Oi), u = t(Yn, ar);
  return {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: a,
    YearPicker: i,
    TimePicker: u,
    QuarterPicker: l
  };
}, pa = (e) => {
  const {
    DatePicker: t,
    WeekPicker: n,
    MonthPicker: r,
    YearPicker: a,
    TimePicker: i,
    QuarterPicker: l
  } = Li(e), u = Yi(e), s = t;
  return s.WeekPicker = n, s.MonthPicker = r, s.YearPicker = a, s.RangePicker = u, s.TimePicker = i, s.QuarterPicker = l, process.env.NODE_ENV !== "production" && (s.displayName = "DatePicker"), s;
}, Mt = pa(vo), Bi = or(Mt, "popupAlign", void 0, "picker");
Mt._InternalPanelDoNotUseOrYouWillBeFired = Bi;
const Wi = or(Mt.RangePicker, "popupAlign", void 0, "picker");
Mt._InternalRangePanelDoNotUseOrYouWillBeFired = Wi;
Mt.generatePicker = pa;
const vl = ({
  format: e = "MM/DD/YYYY",
  ...t
}) => /* @__PURE__ */ ka(
  Mt,
  {
    format: { format: e, type: "mask" },
    placeholder: e,
    ...t
  }
);
export {
  vl as D
};
